export const HR = [
    {
        "employee_id": 13000945,
        "eng_prefix": "Dr.",
        "eng_name": "ROSANNO ROBINDRANAUTH",
        "eng_surname": "RAMCHARAN",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Swiss",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000944,
        "eng_prefix": "Ms.",
        "eng_name": "AREE",
        "eng_surname": "KONGAMNAT",
        "position": "College Secretary",
        "department": "The Office of the Dean",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000943,
        "eng_prefix": "Mr.",
        "eng_name": "Sitta",
        "eng_surname": "Kutsang",
        "position": "General Administration Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000942,
        "eng_prefix": "Ms.",
        "eng_name": "PINYAPATCH",
        "eng_surname": "ISARANUKHUN",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000941,
        "eng_prefix": "Ms.",
        "eng_name": "PORNPIMON",
        "eng_surname": "JANKASEM",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000940,
        "eng_prefix": "Ms.",
        "eng_name": "THANANKORN",
        "eng_surname": "NAIYANANTANANKORN",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000938,
        "eng_prefix": "Mr.",
        "eng_name": "PRANOTE",
        "eng_surname": "SAWANGPISANKIT",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000937,
        "eng_prefix": "Ms.",
        "eng_name": "KUMIKO",
        "eng_surname": "MISHIMA",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Japanese",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000936,
        "eng_prefix": "Ms.",
        "eng_name": "SANIGAN",
        "eng_surname": "HARNSANELUX",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000935,
        "eng_prefix": "Ms.",
        "eng_name": "PIYAPORN",
        "eng_surname": "CHAIYOT",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000934,
        "eng_prefix": "Ms.",
        "eng_name": "WARAPORN",
        "eng_surname": "NUAM-ON",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000933,
        "eng_prefix": "Ms.",
        "eng_name": "UNCHISA",
        "eng_surname": "SAMAIKLANG",
        "position": "General Administration Officer",
        "department": "Research Promotion and Management Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000932,
        "eng_prefix": "Ms.",
        "eng_name": "PUNYAWEE",
        "eng_surname": "THONGKLAD",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000929,
        "eng_prefix": "Mr.",
        "eng_name": "WEERAPHAT",
        "eng_surname": "SANGKAEW",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000928,
        "eng_prefix": "Ms.",
        "eng_name": "PITCHAPON",
        "eng_surname": "KARNDARAT",
        "position": "General Administration Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000927,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "NAHUM CARL",
        "eng_surname": "BROWN",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000926,
        "eng_prefix": "Mr.",
        "eng_name": "NATTACHAI",
        "eng_surname": "YASERM",
        "position": "Technician",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000924,
        "eng_prefix": "Ms.",
        "eng_name": "JARUNEE",
        "eng_surname": "KHAMYOD",
        "position": "General Administration Assistant",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000923,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "YORK HARRY",
        "eng_surname": "GUNTHER",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Canadian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000921,
        "eng_prefix": "MRS.",
        "eng_name": "KURNIATI AILING",
        "eng_surname": "WIRAKOTAN",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Indonesian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000920,
        "eng_prefix": "Mr.",
        "eng_name": "CHRISTOPHER FOWLER",
        "eng_surname": "WILLIS",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000919,
        "eng_prefix": "Mr.",
        "eng_name": "MATTHANA",
        "eng_surname": "TOHWICHIT",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000918,
        "eng_prefix": "Mr.",
        "eng_name": "PATIPAN",
        "eng_surname": "PANPUN",
        "position": "Civil Engineer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000917,
        "eng_prefix": "Mr.",
        "eng_name": "JIRAPAT",
        "eng_surname": "KHAMPLONG",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000916,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "NATTAPOL",
        "eng_surname": "TANGSUPHOOM",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000915,
        "eng_prefix": "Dr.",
        "eng_name": "DEEKANA TIPCHANTA",
        "eng_surname": "KAISER",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000914,
        "eng_prefix": "Ms.",
        "eng_name": "ANTICHA",
        "eng_surname": "ARIYATANASUWAN",
        "position": "Legal Officer",
        "department": "Central Administration Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000911,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "TREEPON",
        "eng_surname": "KIRDNARK",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000910,
        "eng_prefix": "Dr.",
        "eng_name": "PAKAWUT",
        "eng_surname": "JIRADILOK",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000909,
        "eng_prefix": "Dr.",
        "eng_name": "DANIELE",
        "eng_surname": "CARMINATI",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Italian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000908,
        "eng_prefix": "MRS.",
        "eng_name": "SUPANSA",
        "eng_surname": "CHANKHAM",
        "position": "Finance and Accounting Analyst",
        "department": "Academic Services Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000907,
        "eng_prefix": "Ms.",
        "eng_name": "TIPSUDA",
        "eng_surname": "DOUNGTEAN",
        "position": "Part-time Officer",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000905,
        "eng_prefix": "Mr.",
        "eng_name": "MAYSA",
        "eng_surname": "NUTALAI",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000902,
        "eng_prefix": "Dr.",
        "eng_name": "KERRY JEROME",
        "eng_surname": "PUSEY",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000901,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "IVAN ATTWOOD",
        "eng_surname": "STACY",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000900,
        "eng_prefix": "Ms.",
        "eng_name": "JARUKANYA",
        "eng_surname": "NOJAK",
        "position": "Occupation Health Officer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000899,
        "eng_prefix": "Ms.",
        "eng_name": "CHUTIMA",
        "eng_surname": "PUANGTONG",
        "position": "General Administration Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000898,
        "eng_prefix": "Mr.",
        "eng_name": "NATCHAPON",
        "eng_surname": "KADU",
        "position": "Environmentalist",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000897,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "SONGPON",
        "eng_surname": "TEERAKANOK",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000896,
        "eng_prefix": "Ms.",
        "eng_name": "PINYANAN",
        "eng_surname": "WONGTHANASAMITTHI",
        "position": "General Administration Officer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000894,
        "eng_prefix": "Mr.",
        "eng_name": "WATTAHA",
        "eng_surname": "CHALERM",
        "position": "General Administration Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000893,
        "eng_prefix": "Mr.",
        "eng_name": "SORRAWIT",
        "eng_surname": "WANNASORN",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000892,
        "eng_prefix": "Ms.",
        "eng_name": "ARAYA",
        "eng_surname": "SENGSAI",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000890,
        "eng_prefix": "Ms.",
        "eng_name": "RUCHIREK",
        "eng_surname": "ATTAPOOLSAB",
        "position": "Legal Officer",
        "department": "Central Administration Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000889,
        "eng_prefix": "ศ. ดร.",
        "eng_name": "NOPRAENUE SAJJARAX",
        "eng_surname": "DHIRATHITI",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000888,
        "eng_prefix": "Ms.",
        "eng_name": "CHUTINAT",
        "eng_surname": "KORPAYAKKIN",
        "position": "Quality Development  Technical Officer",
        "department": "Planning Monitoring & Evaluation Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000887,
        "eng_prefix": "Ms.",
        "eng_name": "ANCHALEE",
        "eng_surname": "KHUMPHONGPHAN",
        "position": "General Administration Officer",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000885,
        "eng_prefix": "Ms.",
        "eng_name": "PIMMADA",
        "eng_surname": "JAISAWANG",
        "position": "Educator",
        "department": "Strategy and Academic Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000884,
        "eng_prefix": "Mr.",
        "eng_name": "PHUDIS",
        "eng_surname": "SANSERN",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000883,
        "eng_prefix": "Ms.",
        "eng_name": "SUPARADA",
        "eng_surname": "CHAIYAPAN",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000882,
        "eng_prefix": "Mr.",
        "eng_name": "SIRAWITH",
        "eng_surname": "KEAWSOMBOON",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000881,
        "eng_prefix": "Ms.",
        "eng_name": "SUPAWAN",
        "eng_surname": "SUPANEEDIS",
        "position": "Assistant Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000880,
        "eng_prefix": "Mr.",
        "eng_name": "YUTTANA",
        "eng_surname": "SUNTIVONG",
        "position": "Assistant Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000879,
        "eng_prefix": "Dr.",
        "eng_name": "SUPANIDA",
        "eng_surname": "CHANTARIN",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000878,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "ZAK",
        "eng_surname": "CALLAWAY",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Canadian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000877,
        "eng_prefix": "Dr.",
        "eng_name": "CHANCHANOK",
        "eng_surname": "SUDTA",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000876,
        "eng_prefix": "Dr.",
        "eng_name": "ORRATHIP",
        "eng_surname": "GEERATIVUDHIPONG",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000874,
        "eng_prefix": "Mr.",
        "eng_name": "PARIPAT",
        "eng_surname": "SALUBSEE",
        "position": "Public Relation Officer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000871,
        "eng_prefix": "Mr.",
        "eng_name": "NATTHAPONG",
        "eng_surname": "INTHITANON",
        "position": "Mechanical Engineer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000868,
        "eng_prefix": "Mr.",
        "eng_name": "SORAPOL",
        "eng_surname": "ASSAWAKARNJANAKIT",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000867,
        "eng_prefix": "MRS.",
        "eng_name": "JINDARAT",
        "eng_surname": "PLOYSUKSAI",
        "position": "General Service Officer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000866,
        "eng_prefix": "Mr.",
        "eng_name": "SITTHICHAI",
        "eng_surname": "CHANTHACHOT",
        "position": "Engineer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000864,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "PAKORN",
        "eng_surname": "BOVONSOMBAT",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Baby Boomer",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000859,
        "eng_prefix": "Ms.",
        "eng_name": "PANYADAO",
        "eng_surname": "IEM-LA-OR",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000858,
        "eng_prefix": "Dr.",
        "eng_name": "CHALEENA",
        "eng_surname": "PIMPASRI",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000856,
        "eng_prefix": "Ms.",
        "eng_name": "PARICHAT",
        "eng_surname": "PIAMSAHARD",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000855,
        "eng_prefix": "Mr.",
        "eng_name": "KITSADA",
        "eng_surname": "TRONGRUNG",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000853,
        "eng_prefix": "Ms.",
        "eng_name": "JIDAPA",
        "eng_surname": "YOOSAMRAN",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000852,
        "eng_prefix": "Ms.",
        "eng_name": "JUNTIMA",
        "eng_surname": "NUCHYOTIN",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000850,
        "eng_prefix": "Mr.",
        "eng_name": "KIATTISAK",
        "eng_surname": "KHUNSOBNET",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000848,
        "eng_prefix": "Mr.",
        "eng_name": "SITHICHOK",
        "eng_surname": "SONGSRI",
        "position": "Security Guard",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000847,
        "eng_prefix": "MRS.",
        "eng_name": "RATCHAYA",
        "eng_surname": "JAYATILAKA",
        "position": "General Administration Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000846,
        "eng_prefix": "Ms.",
        "eng_name": "NISARAT",
        "eng_surname": "RODKAEW",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000844,
        "eng_prefix": "Ms.",
        "eng_name": "NAPATT",
        "eng_surname": "PIYAWONGWATTHANA",
        "position": "Assistant Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000843,
        "eng_prefix": "Dr.",
        "eng_name": "BOONTIP",
        "eng_surname": "BOONBUMROONGSUK",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000842,
        "eng_prefix": "Ms.",
        "eng_name": "SORAWEE",
        "eng_surname": "PROMSOMBUT",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000841,
        "eng_prefix": "Ms.",
        "eng_name": "AKIRASU",
        "eng_surname": "RODSOODTHI",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000840,
        "eng_prefix": "Ms.",
        "eng_name": "WALATCHAWAN",
        "eng_surname": "AKKASRIWORN",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000838,
        "eng_prefix": "Dr.",
        "eng_name": "SAIFON",
        "eng_surname": "SINGHATONG",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000837,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "BHANBHASSA",
        "eng_surname": "DHUBTHIEN",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000836,
        "eng_prefix": "Mr.",
        "eng_name": "JIRA",
        "eng_surname": "CHATNARATHIP",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000833,
        "eng_prefix": "Mr.",
        "eng_name": "PATIPAN",
        "eng_surname": "WATJANAPRON",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000832,
        "eng_prefix": "Mr.",
        "eng_name": "SERGIO",
        "eng_surname": "ESTEBAN REDONDO",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Spanish",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000831,
        "eng_prefix": "Ms.",
        "eng_name": "MINAR",
        "eng_surname": "NOPPARAT",
        "position": "Public Relation Officer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000830,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "KA TAT NIXON",
        "eng_surname": "CHEN",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Baby Boomer",
        "gender": "Male",
        "nationality": "Hongkonger",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000829,
        "eng_prefix": "Dr.",
        "eng_name": "BRIAN JAMES",
        "eng_surname": "PHILLIPS",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Baby Boomer",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000826,
        "eng_prefix": "Dr.",
        "eng_name": "PRANG",
        "eng_surname": "THARAWANICH",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000824,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "KEVIN ANDREW",
        "eng_surname": "HART",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000823,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "BABLU KUMAR",
        "eng_surname": "DHAR",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Bangladeshi",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000821,
        "eng_prefix": "Dr.",
        "eng_name": "WALLAPA",
        "eng_surname": "SUENGKAMOLPISUT",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000819,
        "eng_prefix": "Ms.",
        "eng_name": "CHUTAMAS",
        "eng_surname": "JAYUUTDISKUL",
        "position": "Assistant Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000816,
        "eng_prefix": "Ms.",
        "eng_name": "PIRIE",
        "eng_surname": "WANGTONG",
        "position": "General Administration Officer",
        "department": "Academic Services Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000814,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "AMONRAT",
        "eng_surname": "THOUMRUNGROJE",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000813,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "ONNIDA",
        "eng_surname": "THONGPRAVATI",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000812,
        "eng_prefix": "Dr.",
        "eng_name": "KENNETH BRENDAN",
        "eng_surname": "HOUSTON",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Irish",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000808,
        "eng_prefix": "Mr.",
        "eng_name": "KITTAPORN",
        "eng_surname": "KITSAWAT",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000806,
        "eng_prefix": "Dr.",
        "eng_name": "PHORUTAI",
        "eng_surname": "PEARNGAM",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000804,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "LOKWEETPUN",
        "eng_surname": "SUPRAWAN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000800,
        "eng_prefix": "Dr.",
        "eng_name": "JAMES ALASTAIR",
        "eng_surname": "WARREN",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000798,
        "eng_prefix": "Dr.",
        "eng_name": "JARUWAN",
        "eng_surname": "SAKULKU",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000795,
        "eng_prefix": "Ms.",
        "eng_name": "SIRIMA",
        "eng_surname": "SANGNARK",
        "position": "General Administration Officer",
        "department": "Academic Services Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000794,
        "eng_prefix": "Dr.",
        "eng_name": "SUPATHIDA",
        "eng_surname": "KULPAVAROPAS",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000793,
        "eng_prefix": "Mr.",
        "eng_name": "IAN THOMAS",
        "eng_surname": "MCDONALD",
        "position": "Assistant Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000791,
        "eng_prefix": "Ms.",
        "eng_name": "NATAPORN",
        "eng_surname": "PRATOOMSUWAN",
        "position": "Legal Officer",
        "department": "Central Administration Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000789,
        "eng_prefix": "Ms.",
        "eng_name": "THANATORN",
        "eng_surname": "SAMANPHIW",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000788,
        "eng_prefix": "Ms.",
        "eng_name": "SUWANNA",
        "eng_surname": "CHUATAMUEN",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000784,
        "eng_prefix": "Mr.",
        "eng_name": "BANDIT",
        "eng_surname": "AINSAHWANG",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000783,
        "eng_prefix": "Mr.",
        "eng_name": "NIKOM",
        "eng_surname": "PHIODAENG",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000781,
        "eng_prefix": "Ms.",
        "eng_name": "HARUTAI",
        "eng_surname": "SRIRUKTHUM",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000780,
        "eng_prefix": "MRS.",
        "eng_name": "CHANETTEE",
        "eng_surname": "POONTHONG",
        "position": "Finance and Accounting Analyst",
        "department": "Research Promotion and Management Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000779,
        "eng_prefix": "Ms.",
        "eng_name": "KANYAKORN",
        "eng_surname": "PENGCHAROEN",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000777,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "DANIEL",
        "eng_surname": "PELLERIN",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "German",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000774,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "PETER",
        "eng_surname": "KURDI",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Hungarian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000773,
        "eng_prefix": "Ms.",
        "eng_name": "PATHIDA",
        "eng_surname": "JAMORNTAMAKUL",
        "position": "Educator",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000772,
        "eng_prefix": "Mr.",
        "eng_name": "KIATPITACK",
        "eng_surname": "PUTTIRUNGSIKUL",
        "position": "Public Relation Officer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000771,
        "eng_prefix": "Ms.",
        "eng_name": "PATTANIT",
        "eng_surname": "MEESAENG",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Z",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000769,
        "eng_prefix": "Ms.",
        "eng_name": "MARY JOAN",
        "eng_surname": "EPPOLITE",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000767,
        "eng_prefix": "Ms.",
        "eng_name": "SIRIPRANG",
        "eng_surname": "CHOTCHAIMONGKOL",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000766,
        "eng_prefix": "Ms.",
        "eng_name": "PHIM-ON",
        "eng_surname": "CHEEVAPHITAKPOL",
        "position": "Educator",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000759,
        "eng_prefix": "Ms.",
        "eng_name": "PHANITA",
        "eng_surname": "POOTEANG-ON",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000755,
        "eng_prefix": "Ms.",
        "eng_name": "JIRAPORN",
        "eng_surname": "KHONGASEAM",
        "position": "General Administration Officer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000752,
        "eng_prefix": "Mr.",
        "eng_name": "PAUL GERARD",
        "eng_surname": "MURPHY",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000750,
        "eng_prefix": "Ms.",
        "eng_name": "PORNWISA",
        "eng_surname": "BUAKHLEE",
        "position": "Education Technologist",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000749,
        "eng_prefix": "Dr.",
        "eng_name": "PLOY",
        "eng_surname": "NIKADANONT",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000747,
        "eng_prefix": "Ms.",
        "eng_name": "PITTAYARAT",
        "eng_surname": "LA-ORNGNUAN",
        "position": "General Administration Assistant",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000746,
        "eng_prefix": "Mr.",
        "eng_name": "Supawat",
        "eng_surname": "Suharitrujjananukool",
        "position": "Mechanical Engineer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000744,
        "eng_prefix": "Ms.",
        "eng_name": "SUPIDA",
        "eng_surname": "WANGRATTANAKORN",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000741,
        "eng_prefix": "Ms.",
        "eng_name": "PIRAPORN",
        "eng_surname": "NUCHPRASERT",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000734,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "CHOMPUNUCH",
        "eng_surname": "PONGJIT",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000731,
        "eng_prefix": "Mr.",
        "eng_name": "WACHIRAWIT",
        "eng_surname": "PARUNAWIN",
        "position": "Research Administrator",
        "department": "Research Promotion and Management Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000728,
        "eng_prefix": "Ms.",
        "eng_name": "JANTRA",
        "eng_surname": "JEEBRIAB",
        "position": "Housekeeper",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000727,
        "eng_prefix": "Ms.",
        "eng_name": "WARITA",
        "eng_surname": "CHOCKEKANUNCHAI",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000725,
        "eng_prefix": "Mr.",
        "eng_name": "PATCHARA",
        "eng_surname": "SINGRUANG",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000723,
        "eng_prefix": "Ms.",
        "eng_name": "JIRATCHA",
        "eng_surname": "ANEKTHANASETH",
        "position": "Educator",
        "department": "Alumni Affairs & Career Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000722,
        "eng_prefix": "Ms.",
        "eng_name": "NAPAPORN",
        "eng_surname": "JINDAPOL",
        "position": "Educator",
        "department": "Alumni Affairs & Career Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000721,
        "eng_prefix": "Dr.",
        "eng_name": "APINYA",
        "eng_surname": "CHANGSANOH",
        "position": "Psychologist",
        "department": "The Office of the Dean",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000708,
        "eng_prefix": "Ms.",
        "eng_name": "PIYAWAN",
        "eng_surname": "JANPEN",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000703,
        "eng_prefix": "Mr.",
        "eng_name": "SUPATTHARACHAI",
        "eng_surname": "KHLONGKAN",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000702,
        "eng_prefix": "Ms.",
        "eng_name": "PALITA",
        "eng_surname": "SITTIVACH",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000696,
        "eng_prefix": "Ms.",
        "eng_name": "CHAKRIYA",
        "eng_surname": "DUANGCHAONA",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000695,
        "eng_prefix": "Ms.",
        "eng_name": "SITATHAL",
        "eng_surname": "NGAMNITHICHAVANUN",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000694,
        "eng_prefix": "Ms.",
        "eng_name": "Warunya",
        "eng_surname": "Bavornkijsutee",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000692,
        "eng_prefix": "Ms.",
        "eng_name": "THANIDA",
        "eng_surname": "SAEU",
        "position": "General Administration Assistant",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000689,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "OLIMPIA CAVOSORA",
        "eng_surname": "RACELA",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000688,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "CLAUS DIETER",
        "eng_surname": "SCHREIER",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Swiss",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000679,
        "eng_prefix": "Mr.",
        "eng_name": "NATTAWATH",
        "eng_surname": "SUKAIM",
        "position": "Technician",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000678,
        "eng_prefix": "Ms.",
        "eng_name": "KAMONTHIP",
        "eng_surname": "KITPANAPORN",
        "position": "General Administration Officer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000675,
        "eng_prefix": "Ms.",
        "eng_name": "SUPHANNEE",
        "eng_surname": "SANOI",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000673,
        "eng_prefix": "Mr.",
        "eng_name": "NOPPORN",
        "eng_surname": "PIROMNOY",
        "position": "Technician",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000672,
        "eng_prefix": "Ms.",
        "eng_name": "SAWAI",
        "eng_surname": "KHRUPHAN",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000671,
        "eng_prefix": "MRS.",
        "eng_name": "KRUEAWAN",
        "eng_surname": "NOIWONG",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000668,
        "eng_prefix": "Mr.",
        "eng_name": "TAWATCHAI",
        "eng_surname": "PHUMKRATHUX",
        "position": "Technician",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000667,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "JI HYE JAIME",
        "eng_surname": "CHUNG",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Korean",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000665,
        "eng_prefix": "Mr.",
        "eng_name": "PONGPHATTRA",
        "eng_surname": "BURAPACHIT",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000663,
        "eng_prefix": "Mr.",
        "eng_name": "PRATUAN",
        "eng_surname": "CHANUDON",
        "position": "Technician",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000662,
        "eng_prefix": "Mr.",
        "eng_name": "NATTAPON",
        "eng_surname": "BOONSUKKHO",
        "position": "Technician",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000661,
        "eng_prefix": "Ms.",
        "eng_name": "ROMMANEE",
        "eng_surname": "PADWICHIT",
        "position": "Information Resource Analyst",
        "department": "Library Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000660,
        "eng_prefix": "Mr.",
        "eng_name": "JAN",
        "eng_surname": "STEVENER",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "German",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000658,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "YOUCEF NASSIM",
        "eng_surname": "DEHOUCHE",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Algerian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000657,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "PLOY",
        "eng_surname": "SUD-ON",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000654,
        "eng_prefix": "Mr.",
        "eng_name": "TINNABHOP",
        "eng_surname": "VEJ APORN",
        "position": "Architect",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000653,
        "eng_prefix": "Mr.",
        "eng_name": "SETRAWUT",
        "eng_surname": "PHUYNONGPHO",
        "position": "Environmentalist",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000652,
        "eng_prefix": "Mr.",
        "eng_name": "CHAKKAPHON",
        "eng_surname": "SINGTOPHUEAK",
        "position": "Audio-Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000651,
        "eng_prefix": "Mr.",
        "eng_name": "NIWAT",
        "eng_surname": "SRISOMPOCH",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000650,
        "eng_prefix": "Ms.",
        "eng_name": "SUTASINEE",
        "eng_surname": "TEEKABUT",
        "position": "Educator",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000649,
        "eng_prefix": "Mr.",
        "eng_name": "KITSANA",
        "eng_surname": "CHUNCHOM",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000648,
        "eng_prefix": "Dr.",
        "eng_name": "AMAN",
        "eng_surname": "SAGGU",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000645,
        "eng_prefix": "Dr.",
        "eng_name": "WEERAPONG",
        "eng_surname": "PHADUNGSUKANAN",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000643,
        "eng_prefix": "Dr.",
        "eng_name": "CHAIVATNA",
        "eng_surname": "SUMETPHONG",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000637,
        "eng_prefix": "Ms.",
        "eng_name": "WANWISA",
        "eng_surname": "LAMTRAKUL",
        "position": "General Administration Officer",
        "department": "Academic Services Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000635,
        "eng_prefix": "Ms.",
        "eng_name": "WASSANA",
        "eng_surname": "KANGNGA",
        "position": "General Administration Assistant",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000628,
        "eng_prefix": "Ms.",
        "eng_name": "SASITHON",
        "eng_surname": "PANYANAK",
        "position": "Research Administrator",
        "department": "Research Promotion and Management Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000627,
        "eng_prefix": "Ms.",
        "eng_name": "ANOTHAI",
        "eng_surname": "SAELEE",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000626,
        "eng_prefix": "Ms.",
        "eng_name": "PAWIRAT",
        "eng_surname": "PROMPES",
        "position": "Educator",
        "department": "Strategy and Academic Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000624,
        "eng_prefix": "Ms.",
        "eng_name": "WARANGKANA",
        "eng_surname": "YIMKOSOL",
        "position": "Scientist",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000623,
        "eng_prefix": "Ms.",
        "eng_name": "PORNTIWA",
        "eng_surname": "KIJSASON",
        "position": "General Administration Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000618,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "ROMAN",
        "eng_surname": "MEINHOLD",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Dutch",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000614,
        "eng_prefix": "Mr.",
        "eng_name": "DACHA",
        "eng_surname": "NAMPRADIT",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000612,
        "eng_prefix": "Mr.",
        "eng_name": "SAKOL",
        "eng_surname": "WIKAEWMORAKOT",
        "position": "Educator",
        "department": "Strategy and Academic Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000611,
        "eng_prefix": "Ms.",
        "eng_name": "JANJIRA",
        "eng_surname": "PHONGBUNDHITWATTHANA",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000599,
        "eng_prefix": "Mr.",
        "eng_name": "ANDREW CHARLES",
        "eng_surname": "FORSTER",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Australian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000598,
        "eng_prefix": "Mr.",
        "eng_name": "COLIN MORGAN",
        "eng_surname": "CARPENTER",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000595,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "THOTSAPORN",
        "eng_surname": "THANATIPANONDA",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000594,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "MANCHUTA",
        "eng_surname": "DANGKULWANICH",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000589,
        "eng_prefix": "Ms.",
        "eng_name": "VARUNEE",
        "eng_surname": "RAUDSOOK",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000588,
        "eng_prefix": "Ms.",
        "eng_name": "TIPWIMON",
        "eng_surname": "BUACHUM",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000587,
        "eng_prefix": "Ms.",
        "eng_name": "KANOKWAN",
        "eng_surname": "KARAWAKE",
        "position": "Educator",
        "department": "Graduate Program Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000580,
        "eng_prefix": "Mr.",
        "eng_name": "ANAN",
        "eng_surname": "SALANOK",
        "position": "Security Guard",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000579,
        "eng_prefix": "Dr.",
        "eng_name": "CHRISTIN  MARIE",
        "eng_surname": "GROTHAUS",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "German",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000578,
        "eng_prefix": "Mr.",
        "eng_name": "HENRY  HUMPHREY",
        "eng_surname": "PFISTER",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000576,
        "eng_prefix": "Mr.",
        "eng_name": "ADRIANO  ALBERTO",
        "eng_surname": "QUIETI",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000575,
        "eng_prefix": "Dr.",
        "eng_name": "NUNNAPAN",
        "eng_surname": "PUATHANAWAT",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000571,
        "eng_prefix": "Ms.",
        "eng_name": "KANOKWAN",
        "eng_surname": "SANGANAN",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000569,
        "eng_prefix": "Ms.",
        "eng_name": "RAWEEWAN",
        "eng_surname": "THANUTHONG",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000568,
        "eng_prefix": "Dr.",
        "eng_name": "JERIMIAH  FREEMAN",
        "eng_surname": "MORRIS",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000567,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "SARAYUT",
        "eng_surname": "NATHAPHAN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000565,
        "eng_prefix": "Mr.",
        "eng_name": "CHATWAROOT",
        "eng_surname": "DULYACHAI",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000563,
        "eng_prefix": "Ms.",
        "eng_name": "SONGROT",
        "eng_surname": "KITSAWAT",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000559,
        "eng_prefix": "Ms.",
        "eng_name": "NATTIKA",
        "eng_surname": "PHUNYATERA",
        "position": "Educator",
        "department": "Alumni Affairs & Career Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000553,
        "eng_prefix": "Ms.",
        "eng_name": "WORANAN",
        "eng_surname": "APITHARANON",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000549,
        "eng_prefix": "Dr.",
        "eng_name": "TARA",
        "eng_surname": "CHALERMSONGSAK",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000548,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "TUMNOON",
        "eng_surname": "CHARASLERTRANGSI",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000546,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "VARANG",
        "eng_surname": "WIRIYAWIT",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000543,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "VIRIYA",
        "eng_surname": "TAECHARUNGROJ",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000541,
        "eng_prefix": "Ms.",
        "eng_name": "THEERANUN",
        "eng_surname": "LEKSUTHEE",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000539,
        "eng_prefix": "Mr.",
        "eng_name": "LEIGH",
        "eng_surname": "PEARSON",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000538,
        "eng_prefix": "Dr.",
        "eng_name": "ANJANA",
        "eng_surname": "SUKUMARY",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Indian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000537,
        "eng_prefix": "Dr.",
        "eng_name": "SARINYA",
        "eng_surname": "SUNGKATAVAT",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000533,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "PORNRAT",
        "eng_surname": "RUENGROT",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000532,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "PHASSAWAN",
        "eng_surname": "SUNTRARUK",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000531,
        "eng_prefix": "Mr.",
        "eng_name": "NATCHAPHON",
        "eng_surname": "KHUEANKHAE",
        "position": "Technician",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000529,
        "eng_prefix": "Ms.",
        "eng_name": "BUDSARA",
        "eng_surname": "YARNKOOLWONG",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000524,
        "eng_prefix": "Ms.",
        "eng_name": "SUPITCHA",
        "eng_surname": "NUKKONG",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000522,
        "eng_prefix": "Mr.",
        "eng_name": "THREEPAK",
        "eng_surname": "PATTARASUMUN",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000518,
        "eng_prefix": "Ms.",
        "eng_name": "RUNGTIPA",
        "eng_surname": "SAE-TEAW",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000517,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "CHANCHAI",
        "eng_surname": "PHONTHANUKITITHAWORN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000516,
        "eng_prefix": "Dr.",
        "eng_name": "RANGSON",
        "eng_surname": "CHIRAKRANONT",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000514,
        "eng_prefix": "Ms.",
        "eng_name": "PAPASSORN",
        "eng_surname": "PEARPLUK",
        "position": "General Administration Officer",
        "department": "Graduate Program Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000513,
        "eng_prefix": "Dr.",
        "eng_name": "HARDINA",
        "eng_surname": "OHLENDORF",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "German",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000511,
        "eng_prefix": "Mr.",
        "eng_name": "KITTIPHAT",
        "eng_surname": "PHANPRACHA",
        "position": "Electrician",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000506,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "KANAT",
        "eng_surname": "TANGWONGSAN",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000505,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "ISABEL MARIA",
        "eng_surname": "MEDALHO PEREIRA DE FREITAS RODRIGUES",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Portuguese",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000504,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "ALESSANDRO",
        "eng_surname": "STASI",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Italian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000502,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "APIRADEE",
        "eng_surname": "WONGKITRUNGRUENG",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000501,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "WANKWAN",
        "eng_surname": "POLACHAN",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000493,
        "eng_prefix": "Ms.",
        "eng_name": "WIMONSIRI",
        "eng_surname": "HEMTANON",
        "position": "Assistant Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000492,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "SUWADEE",
        "eng_surname": "TALAWANICH",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000491,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "KANIX",
        "eng_surname": "BUKKAVESA",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000490,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "PATSARIN  RODPOTHONG",
        "eng_surname": "WONGKAMHANG",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000489,
        "eng_prefix": "Mr.",
        "eng_name": "JOSEPH  ANTHONY",
        "eng_surname": "SERRANI",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000484,
        "eng_prefix": "Mr.",
        "eng_name": "WAI TAK",
        "eng_surname": "TO",
        "position": "Assistant Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Chinese",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000481,
        "eng_prefix": "Ms.",
        "eng_name": "THIPSUKHON",
        "eng_surname": "CHUENSODSAI",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000480,
        "eng_prefix": "Mr.",
        "eng_name": "KRIT",
        "eng_surname": "PIYARATTANAPIPHAT",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000478,
        "eng_prefix": "Ms.",
        "eng_name": "YANIN",
        "eng_surname": "SOMSRI",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000477,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "CHATCHAWAN",
        "eng_surname": "PANRAKSA",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000476,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "ARAM",
        "eng_surname": "TANGBOONDUANGJIT",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000472,
        "eng_prefix": "Mr.",
        "eng_name": "THIRARAT",
        "eng_surname": "MANEEKUN",
        "position": "Electrical Engineer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000470,
        "eng_prefix": "Mr.",
        "eng_name": "ROMAN",
        "eng_surname": "CHIRASANTA",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000465,
        "eng_prefix": "Ms.",
        "eng_name": "TASANEE",
        "eng_surname": "SATEVONGSA",
        "position": "Human Resources Officer",
        "department": "The Office of the Dean",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000462,
        "eng_prefix": "Mr.",
        "eng_name": "THANAWUT",
        "eng_surname": "MAKAEO",
        "position": "General Service Officer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000461,
        "eng_prefix": "Dr.",
        "eng_name": "MONNAPAT",
        "eng_surname": "KETKUNTORN",
        "position": "Plan and Policy Analyst",
        "department": "Planning Monitoring & Evaluation Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000460,
        "eng_prefix": "Ms.",
        "eng_name": "SUKANYA",
        "eng_surname": "RATTANATARATIKUN",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000450,
        "eng_prefix": "Ms.",
        "eng_name": "KANOKEPORN",
        "eng_surname": "PREMPIYAMONTRI",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000449,
        "eng_prefix": "Ms.",
        "eng_name": "METPARIYA",
        "eng_surname": "KIRATIWATTANAKOON",
        "position": "Education Technologist",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000448,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "THANARERK",
        "eng_surname": "THANAKIJSOMBAT",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000447,
        "eng_prefix": "Dr.",
        "eng_name": "NUTTHABOON",
        "eng_surname": "PORNRATTANACHAROEN",
        "position": "Public Relation Officer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000446,
        "eng_prefix": "MRS.",
        "eng_name": "ANCHISA",
        "eng_surname": "KANJANARUJIVUT",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000444,
        "eng_prefix": "Mr.",
        "eng_name": "PRAWIT",
        "eng_surname": "HNGIMHYUN",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000439,
        "eng_prefix": "Ms.",
        "eng_name": "KUNYAPAT",
        "eng_surname": "KAEWCHA",
        "position": "General Administration Officer",
        "department": "Central Administration Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000438,
        "eng_prefix": "Ms.",
        "eng_name": "PUCKVIPA",
        "eng_surname": "UA-AMORNWANIT",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000437,
        "eng_prefix": "Ms.",
        "eng_name": "SITHAPAN",
        "eng_surname": "VIRIYAMANO",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000436,
        "eng_prefix": "Mr.",
        "eng_name": "CHALIT",
        "eng_surname": "LAPROM",
        "position": "Security Guard",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000433,
        "eng_prefix": "Dr.",
        "eng_name": "KAL",
        "eng_surname": "ELLE",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000431,
        "eng_prefix": "Mr.",
        "eng_name": "ANDREW",
        "eng_surname": "LEICESTER",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Australian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000430,
        "eng_prefix": "MRS.",
        "eng_name": "DUANGDUEAN",
        "eng_surname": "SAENGPRAEW",
        "position": "Educator",
        "department": "Strategy and Academic Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000428,
        "eng_prefix": "Mr.",
        "eng_name": "JETAPASS",
        "eng_surname": "SAOTHONG",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000427,
        "eng_prefix": "Ms.",
        "eng_name": "PUNYAWEE",
        "eng_surname": "PHUENGWATTANAPANICH",
        "position": "Educator",
        "department": "Strategy and Academic Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000424,
        "eng_prefix": "Ms.",
        "eng_name": "THONGDA",
        "eng_surname": "WONGSURIYA",
        "position": "Housekeeper",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000421,
        "eng_prefix": "Ms.",
        "eng_name": "JIDAPA",
        "eng_surname": "JOSEN",
        "position": "General Administration Officer",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000414,
        "eng_prefix": "Ms.",
        "eng_name": "NUTTAPORN",
        "eng_surname": "HAMONTRI",
        "position": "Educator",
        "department": "Strategy and Academic Development Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000413,
        "eng_prefix": "Mr.",
        "eng_name": "SAKON",
        "eng_surname": "LUMPONGPHAN",
        "position": "Computer Information Analyst",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000409,
        "eng_prefix": "Mr.",
        "eng_name": "WICHIAN",
        "eng_surname": "YUENYAO",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000408,
        "eng_prefix": "Mr.",
        "eng_name": "GREG",
        "eng_surname": "NOLAND",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000407,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "XIAOXIA",
        "eng_surname": "WEI",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Chinese",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000404,
        "eng_prefix": "Ms.",
        "eng_name": "THANYA",
        "eng_surname": "UTTRAPORN",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000401,
        "eng_prefix": "Ms.",
        "eng_name": "SUNTAREE",
        "eng_surname": "SANGSEE",
        "position": "General Administration Officer",
        "department": "Central Administration Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000399,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "MATTHEW ROBERT",
        "eng_surname": "FERGUSON",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Canadian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000396,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "SUPARA",
        "eng_surname": "KAPASUWAN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000392,
        "eng_prefix": "Mr.",
        "eng_name": "NOPPADOL",
        "eng_surname": "PHUEAKLAO",
        "position": "Security Guard",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000391,
        "eng_prefix": "Mr.",
        "eng_name": "SUCHAI",
        "eng_surname": "KRASAESOM",
        "position": "Gardener",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000390,
        "eng_prefix": "Dr.",
        "eng_name": "JUAN CARLOS",
        "eng_surname": "OLMOS ALCOY",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Spanish",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000388,
        "eng_prefix": "Mr.",
        "eng_name": "GEORGE T.",
        "eng_surname": "AMURAO",
        "position": "Web Content Specialist",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Filipino",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000380,
        "eng_prefix": "MRS.",
        "eng_name": "THITAREE",
        "eng_surname": "SANORKUM",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000379,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "DOLCHAI",
        "eng_surname": "LA-ORNUAL",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000376,
        "eng_prefix": "Ms.",
        "eng_name": "SUPAPORN",
        "eng_surname": "PHOMSURIN",
        "position": "Scientist",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000374,
        "eng_prefix": "Mr.",
        "eng_name": "JULIEN",
        "eng_surname": "HARDY",
        "position": "Assistant Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "French",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000372,
        "eng_prefix": "Ms.",
        "eng_name": "PATTAKA",
        "eng_surname": "SA-NGIMNET",
        "position": "Assistant Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Assistant Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000370,
        "eng_prefix": "Ms.",
        "eng_name": "PORNNAPAT",
        "eng_surname": "PRAMCHOTE",
        "position": "Quality Development  Technical Officer",
        "department": "Planning Monitoring & Evaluation Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000359,
        "eng_prefix": "Mr.",
        "eng_name": "NUTTAWUT",
        "eng_surname": "PINPRACHA",
        "position": "General Service Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000358,
        "eng_prefix": "Ms.",
        "eng_name": "PANISARA",
        "eng_surname": "AKARASINAKUL",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000357,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "BENJALUX",
        "eng_surname": "SAKUNASINGHA",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000351,
        "eng_prefix": "Mr.",
        "eng_name": "NATTHAPONG",
        "eng_surname": "BUASAI",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000347,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "DISSATAT",
        "eng_surname": "PRASERTSAKUL",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000346,
        "eng_prefix": "Prof.",
        "eng_name": "CHULATHIDA",
        "eng_surname": "CHOMCHAI",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000344,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "CHAYANANT",
        "eng_surname": "HONGFA",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000341,
        "eng_prefix": "Mr.",
        "eng_name": "BOONLUA",
        "eng_surname": "BUASRI",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000339,
        "eng_prefix": "Ms.",
        "eng_name": "KAMONTHIP",
        "eng_surname": "KITTIWUTRUNGRUANG",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000333,
        "eng_prefix": "Ms.",
        "eng_name": "PRANG",
        "eng_surname": "SIRIPHAND",
        "position": "Public Relation Officer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000327,
        "eng_prefix": "Dr.",
        "eng_name": "VEERADES",
        "eng_surname": "PANVISAVAS",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000313,
        "eng_prefix": "Mr.",
        "eng_name": "KORAKOT",
        "eng_surname": "INTARAWECH",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000308,
        "eng_prefix": "Ms.",
        "eng_name": "AGNIESZKA TERESA",
        "eng_surname": "ATTHASIT",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Polish",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000305,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "CHANIDA",
        "eng_surname": "HANSAWASDI",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000299,
        "eng_prefix": "Mr.",
        "eng_name": "KITTIRAT",
        "eng_surname": "PRUETHONG",
        "position": "Electrical Engineer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000295,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "MALINVISA",
        "eng_surname": "SAKDIYAKORN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000294,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "PANDEJ",
        "eng_surname": "CHINTRAKARN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000293,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "DYNAYA",
        "eng_surname": "BHUTIPUNTHU",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000291,
        "eng_prefix": "Dr.",
        "eng_name": "MILLICENT MARGARET AMANDA JANE",
        "eng_surname": "YOUNG",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000287,
        "eng_prefix": "Assoc.Prof.",
        "eng_name": "DALE ALAN",
        "eng_surname": "KONSTANZ",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000286,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "ANALIZA LIEZL PEREZ",
        "eng_surname": "AMURAO",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Filipino",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000284,
        "eng_prefix": "Dr.",
        "eng_name": "BRYAN EDWARD",
        "eng_surname": "OTT",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000282,
        "eng_prefix": "Ms.",
        "eng_name": "RUJIRA",
        "eng_surname": "SUKUMPEE",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000281,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "NUNTANA",
        "eng_surname": "UDOMKIT",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000276,
        "eng_prefix": "Mr.",
        "eng_name": "PONGSATORN",
        "eng_surname": "KAEWMESRI",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000271,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "WALANCHALEE",
        "eng_surname": "WATTANACHAROENSIL",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000270,
        "eng_prefix": "Mr.",
        "eng_name": "ARTIT",
        "eng_surname": "TAWEEDEIT",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000269,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "ORNLATCHA",
        "eng_surname": "SIVARAK",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000258,
        "eng_prefix": "Ms.",
        "eng_name": "CAROL ANN",
        "eng_surname": "SIATRAS",
        "position": "Lecturer",
        "department": "Fine and Applied  Arts Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000256,
        "eng_prefix": "Mr.",
        "eng_name": "SUPAT",
        "eng_surname": "CHANPEN",
        "position": "General Administration Officer",
        "department": "Central Administration Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000250,
        "eng_prefix": "Mr.",
        "eng_name": "CHRISTIAN",
        "eng_surname": "OESTERHELD",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Dutch",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000249,
        "eng_prefix": "Mr.",
        "eng_name": "SANTAS",
        "eng_surname": "LOMSINSUB",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000248,
        "eng_prefix": "Mr.",
        "eng_name": "KESWIT",
        "eng_surname": "POOPUAK",
        "position": "Computer Programmer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000243,
        "eng_prefix": "Ms.",
        "eng_name": "YUWADEE",
        "eng_surname": "CHUNLIM",
        "position": "Librarian",
        "department": "Library Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000242,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "WILLIAM J.",
        "eng_surname": "JONES",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000239,
        "eng_prefix": "Mr.",
        "eng_name": "PREECHA",
        "eng_surname": "RUAMSAMAK",
        "position": "General Service Officer",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000237,
        "eng_prefix": "Mr.",
        "eng_name": "ADISORN",
        "eng_surname": "SRIWICHA",
        "position": "Electrician",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000234,
        "eng_prefix": "Mr.",
        "eng_name": "PARINYA",
        "eng_surname": "SRIKHAOW",
        "position": "General Service Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000222,
        "eng_prefix": "Mr.",
        "eng_name": "MARK E.",
        "eng_surname": "MANNING",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000221,
        "eng_prefix": "Ms.",
        "eng_name": "MARIA",
        "eng_surname": "SIMON",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000217,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "BOONYANIT",
        "eng_surname": "MATHAYOMCHAN",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000216,
        "eng_prefix": "Ms.",
        "eng_name": "PUVISA",
        "eng_surname": "QIUJUAN",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000213,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "GERALD",
        "eng_surname": "MOSHAMMER",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Austrian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000209,
        "eng_prefix": "Ms.",
        "eng_name": "SOMPHAT",
        "eng_surname": "SUKSAMAI",
        "position": "General Administration Officer",
        "department": "Central Administration Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000208,
        "eng_prefix": "Dr.",
        "eng_name": "PORNCHANOK",
        "eng_surname": "TANEKITTANA",
        "position": "General Administration Officer",
        "department": "Academic Services Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000203,
        "eng_prefix": "Mr.",
        "eng_name": "NATTHAPATCH",
        "eng_surname": "SIRIPHATCHARACHAIKUL",
        "position": "Scientist",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000202,
        "eng_prefix": "Ms.",
        "eng_name": "JITTRAPA",
        "eng_surname": "VUTTHIKORNPUN",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000200,
        "eng_prefix": "Ms.",
        "eng_name": "TEERAWAN",
        "eng_surname": "NUNTAKIJ",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000199,
        "eng_prefix": "Ms.",
        "eng_name": "ROMRAWIN",
        "eng_surname": "HOMSAWAN",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000196,
        "eng_prefix": "Ms.",
        "eng_name": "SARINYA",
        "eng_surname": "SAIHOM",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000195,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "NATANAREE",
        "eng_surname": "POSRITHONG",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000192,
        "eng_prefix": "Ms.",
        "eng_name": "WIMOL",
        "eng_surname": "THONGRUNG",
        "position": "General Administration Officer",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000187,
        "eng_prefix": "Mr.",
        "eng_name": "YUTHAPONG",
        "eng_surname": "THITIMONGKOL",
        "position": "Security Guard",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000185,
        "eng_prefix": "Mr.",
        "eng_name": "CHAIWAT",
        "eng_surname": "GRINSRITHONG",
        "position": "Technician",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000183,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "KANDAPA",
        "eng_surname": "THANASUTA",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000181,
        "eng_prefix": "Mr.",
        "eng_name": "PRATCHAYA",
        "eng_surname": "LEELAPRATCHAYANONT",
        "position": "Graphic Designer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000178,
        "eng_prefix": "Ms.",
        "eng_name": "ANISA",
        "eng_surname": "MEKAPORN",
        "position": "General Administration Officer",
        "department": "The Office of the Dean",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000177,
        "eng_prefix": "MRS.",
        "eng_name": "SOPA",
        "eng_surname": "NARKPOMCHIN",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000173,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "KAEWTA",
        "eng_surname": "MUANGASAME",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000170,
        "eng_prefix": "Mr.",
        "eng_name": "WASAN",
        "eng_surname": "BAIDAY",
        "position": "Gardener",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000169,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "NIRUTCHARA",
        "eng_surname": "LAOHAPRASIT",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000167,
        "eng_prefix": "Ms.",
        "eng_name": "JEERAWAN",
        "eng_surname": "THONGSAKOL",
        "position": "Educator",
        "department": "Research Promotion and Management Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000163,
        "eng_prefix": "Dr.",
        "eng_name": "KRITYA",
        "eng_surname": "BUNCHONGCHIT",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000161,
        "eng_prefix": "Mr.",
        "eng_name": "GARY FRANK",
        "eng_surname": "WADDELL II",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "American",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000160,
        "eng_prefix": "Mr.",
        "eng_name": "AEKSING",
        "eng_surname": "WEERASAWAINON",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000159,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "SIRITHIDA",
        "eng_surname": "CHAIVISUTTANGKUN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000158,
        "eng_prefix": "Mr.",
        "eng_name": "RATTASORN",
        "eng_surname": "RODKRATHUEK",
        "position": "Technician",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000157,
        "eng_prefix": "Ms.",
        "eng_name": "SUNTHAREE",
        "eng_surname": "TUMMAVIPHAT",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000149,
        "eng_prefix": "Ms.",
        "eng_name": "NUCHJAREE",
        "eng_surname": "CHANTORN",
        "position": "Librarian",
        "department": "Library Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000148,
        "eng_prefix": "Ms.",
        "eng_name": "SUWASSA",
        "eng_surname": "PLUBPLACHAI",
        "position": "Computer Information Analyst",
        "department": "Library Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000146,
        "eng_prefix": "Ms.",
        "eng_name": "SITA",
        "eng_surname": "WITCHAYAKIJKUL",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000144,
        "eng_prefix": "MRS.",
        "eng_name": "PATTHARAT",
        "eng_surname": "UATHAWEESAMPHAN",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000143,
        "eng_prefix": "MRS.",
        "eng_name": "NARIRAT",
        "eng_surname": "RODMA",
        "position": "Educator",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000142,
        "eng_prefix": "Mr.",
        "eng_name": "SITTICHOKE",
        "eng_surname": "KRASIN",
        "position": "General Service Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000141,
        "eng_prefix": "Mr.",
        "eng_name": "SOMPON",
        "eng_surname": "BUACHAN",
        "position": "Educator",
        "department": "Graduate Program Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000139,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "YINGYOT",
        "eng_surname": "CHIARAVUTTHI",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000137,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "THANYAWEE",
        "eng_surname": "PRATOOMSUWAN",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000136,
        "eng_prefix": "Mr.",
        "eng_name": "SURASAK",
        "eng_surname": "SAWANGPONG",
        "position": "Security Guard",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000134,
        "eng_prefix": "Mr.",
        "eng_name": "SANTI",
        "eng_surname": "PLOYSUGSAI",
        "position": "Driver",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000128,
        "eng_prefix": "Ms.",
        "eng_name": "THIDARAT",
        "eng_surname": "CHARUWAT",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000125,
        "eng_prefix": "MRS.",
        "eng_name": "SAWITREE",
        "eng_surname": "PITCHAYACHAI",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000120,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "RUCHI",
        "eng_surname": "AGARWAL",
        "position": "Lecturer",
        "department": "Social Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Indian",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000116,
        "eng_prefix": "Ms.",
        "eng_name": "UBONWAN",
        "eng_surname": "SONGKRANTANON",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000115,
        "eng_prefix": "MRS.",
        "eng_name": "ANCHALEE",
        "eng_surname": "LEELAPRATCHAYANONT",
        "position": "General Administration Officer",
        "department": "Academic Services Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000113,
        "eng_prefix": "MRS.",
        "eng_name": "SUPATRA",
        "eng_surname": "NONTAPHA",
        "position": "Librarian",
        "department": "Library Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000112,
        "eng_prefix": "Mr.",
        "eng_name": "SONGPOLE",
        "eng_surname": "SANGTHONG",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000110,
        "eng_prefix": "Dr.",
        "eng_name": "LADDAWAN",
        "eng_surname": "JIANVITTAYAKIT",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000109,
        "eng_prefix": "Ms.",
        "eng_name": "VEENA",
        "eng_surname": "THAVORNLOHA",
        "position": "Educator",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000107,
        "eng_prefix": "Dr.",
        "eng_name": "PRATEEP",
        "eng_surname": "WONGVERAYUT",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000100,
        "eng_prefix": "Ms.",
        "eng_name": "WANNAPAN",
        "eng_surname": "ONYAEM",
        "position": "Plan and Policy Analyst",
        "department": "Planning Monitoring & Evaluation Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000098,
        "eng_prefix": "Ms.",
        "eng_name": "YUBOL",
        "eng_surname": "BOONJARAN",
        "position": "Education Technologist",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000097,
        "eng_prefix": "Mr.",
        "eng_name": "CHAYANON",
        "eng_surname": "POONTHONG",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000096,
        "eng_prefix": "Ms.",
        "eng_name": "WORADA",
        "eng_surname": "APIRAT",
        "position": "Foreign Relations Officer",
        "department": "International Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000091,
        "eng_prefix": "Mr.",
        "eng_name": "RUSSELL",
        "eng_surname": "PATTINSON",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000089,
        "eng_prefix": "MRS.",
        "eng_name": "SAKULLAYA",
        "eng_surname": "KRASIN",
        "position": "Educator",
        "department": "Graduate Program Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000088,
        "eng_prefix": "Dr.",
        "eng_name": "WAYNE NICHOLAS",
        "eng_surname": "PHILLIPS",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "British",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000087,
        "eng_prefix": "Mr.",
        "eng_name": "VORODOM",
        "eng_surname": "VIRAVONG",
        "position": "Instructor",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Instructor",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000083,
        "eng_prefix": "MRS.",
        "eng_name": "JUMLONG",
        "eng_surname": "PHIROMNOI",
        "position": "Housekeeper",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000081,
        "eng_prefix": "MRS.",
        "eng_name": "ROSSUKON",
        "eng_surname": "PRANET",
        "position": "Public Relation Officer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000080,
        "eng_prefix": "Mr.",
        "eng_name": "WIROT",
        "eng_surname": "SUPACHOKCHONLAKUL",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000078,
        "eng_prefix": "Mr.",
        "eng_name": "TANASAK",
        "eng_surname": "POUNGSUB",
        "position": "General Service Officer",
        "department": "Aditayathorn Building Group",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000075,
        "eng_prefix": "Ms.",
        "eng_name": "PHATSIRI",
        "eng_surname": "CHANCHIM",
        "position": "Computer Information Analyst",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000074,
        "eng_prefix": "Mr.",
        "eng_name": "PORAMIN",
        "eng_surname": "BHEGANAN",
        "position": "Lecturer",
        "department": "Science Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000073,
        "eng_prefix": "Mr.",
        "eng_name": "THAMMACHART",
        "eng_surname": "KANJANAPINYO",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000072,
        "eng_prefix": "Ms.",
        "eng_name": "KETVAREE",
        "eng_surname": "PHATANAKEAW",
        "position": "Public Relation Officer",
        "department": "Corporate Communications Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000069,
        "eng_prefix": "Ms.",
        "eng_name": "PRAEWTHIP",
        "eng_surname": "WONGPAIBOON",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000066,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "MICHAEL",
        "eng_surname": "NAGLIS",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000065,
        "eng_prefix": "MRS.",
        "eng_name": "JUTHARAT",
        "eng_surname": "THIPBOONSUP",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000061,
        "eng_prefix": "Ms.",
        "eng_name": "PIMLADA",
        "eng_surname": "RUNGPATMETEEKUL",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000059,
        "eng_prefix": "Assoc.Prof.",
        "eng_name": "TAKAYOSHI",
        "eng_surname": "FUJIWARA",
        "position": "Lecturer",
        "department": "Humanities and Language Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Japanese",
        "employee_count": 1,
        "is_thai": 0,
        "is_foreigner": 1
    },
    {
        "employee_id": 13000058,
        "eng_prefix": "MRS.",
        "eng_name": "NATCHA",
        "eng_surname": "PHOUNGSOMBAT",
        "position": "Supply Analyst",
        "department": "Procurement Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000053,
        "eng_prefix": "Asst.Prof. Dr.",
        "eng_name": "SOMPONG",
        "eng_surname": "AMNUAY-NGERNTRA",
        "position": "Lecturer",
        "department": "Tourism and Hospitality Management Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000052,
        "eng_prefix": "Ms.",
        "eng_name": "KETSIRIN",
        "eng_surname": "CHEWPRECHA",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000051,
        "eng_prefix": "Assoc.Prof. Dr.",
        "eng_name": "VEERA",
        "eng_surname": "BHATIASEVI",
        "position": "Lecturer",
        "department": "Business Administration Division",
        "muic_staff_type": "Lecturer",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000050,
        "eng_prefix": "Ms.",
        "eng_name": "TANNALIN",
        "eng_surname": "SIRIPHATCHARACHAIKUL",
        "position": "Information Resource Analyst",
        "department": "Library Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000048,
        "eng_prefix": "Mr.",
        "eng_name": "PONLAPAT",
        "eng_surname": "MUNYANON",
        "position": "Computer Technical Officer",
        "department": "Information Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000045,
        "eng_prefix": "Ms.",
        "eng_name": "PATHYPHORN",
        "eng_surname": "THITIMONGKOL",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000039,
        "eng_prefix": "Mr.",
        "eng_name": "KATIPOOM",
        "eng_surname": "NOIWONG",
        "position": "General Service Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen Y",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000035,
        "eng_prefix": "MRS.",
        "eng_name": "CHANITA",
        "eng_surname": "NGAMKUNNATHAM",
        "position": "Human Resources Officer",
        "department": "Human Resources Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000033,
        "eng_prefix": "Ms.",
        "eng_name": "SUDAPORN",
        "eng_surname": "YOOSAWAS",
        "position": "Educator",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000031,
        "eng_prefix": "Mr.",
        "eng_name": "ANITUS",
        "eng_surname": "RAVUNGCHON",
        "position": "General Service Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000029,
        "eng_prefix": "Ms.",
        "eng_name": "SATJA",
        "eng_surname": "SOPHA",
        "position": "Educator",
        "department": "Preparation Center for Languages and Mathematics",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000024,
        "eng_prefix": "Mr.",
        "eng_name": "KAWIN",
        "eng_surname": "MONGKOLPRAPA",
        "position": "Plan and Policy Analyst",
        "department": "Planning Monitoring & Evaluation Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000023,
        "eng_prefix": "Ms.",
        "eng_name": "CHANPEN",
        "eng_surname": "KHUNSONG",
        "position": "General Administration Officer",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000022,
        "eng_prefix": "Mr.",
        "eng_name": "PONGPAKDEE",
        "eng_surname": "HONGTHONG",
        "position": "Audio Visual Officer",
        "department": "Educational Technology Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000020,
        "eng_prefix": "Mr.",
        "eng_name": "PUTTHIPAT",
        "eng_surname": "SIRICHOTCHARINTHORN",
        "position": "General Service Officer",
        "department": "Educational Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Male",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000019,
        "eng_prefix": "MRS.",
        "eng_name": "PRAPAI",
        "eng_surname": "PIROMNOI",
        "position": "General Service Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000018,
        "eng_prefix": "Ms.",
        "eng_name": "RANDA",
        "eng_surname": "RUJICHINNAWONG",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000017,
        "eng_prefix": "MRS.",
        "eng_name": "PORNTHIP",
        "eng_surname": "PIAMKHUM",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000016,
        "eng_prefix": "Ms.",
        "eng_name": "SUCHANANT",
        "eng_surname": "TANJAROENTHAM",
        "position": "General Administration Officer",
        "department": "Operation and Environment Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000015,
        "eng_prefix": "MRS.",
        "eng_name": "PATHITA",
        "eng_surname": "SUWANWONG",
        "position": "Educator",
        "department": "Admissions and Registrar Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000014,
        "eng_prefix": "Ms.",
        "eng_name": "SASITHORN",
        "eng_surname": "ROJSONGKRAM",
        "position": "Educator",
        "department": "Student Affairs Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    },
    {
        "employee_id": 13000013,
        "eng_prefix": "MRS.",
        "eng_name": "ARUNEE",
        "eng_surname": "KORSAWADPAT",
        "position": "Finance and Accounting Analyst",
        "department": "Finance & Accounting Section",
        "muic_staff_type": "Supporting Staff",
        "generation": "Gen X",
        "gender": "Female",
        "nationality": "Thai",
        "employee_count": 1,
        "is_thai": 1,
        "is_foreigner": 0
    }
]



// [
//     {
//         "employee_id": "13000939",
//         "eng_prefix": "MS.",
//         "eng_name": "PRAEWA",
//         "eng_surname": "PITCHAYACHAI",
//         "position": "Part-time Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000938",
//         "eng_prefix": "MR.",
//         "eng_name": "PRANOTE",
//         "eng_surname": "SAWANGPISANKIT",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000937",
//         "eng_prefix": "MS.",
//         "eng_name": "KUMIKO",
//         "eng_surname": "MISHIMA",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Japanese",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000936",
//         "eng_prefix": "MS.",
//         "eng_name": "SANIGAN",
//         "eng_surname": "HARNSANELUX",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000935",
//         "eng_prefix": "MS.",
//         "eng_name": "PIYAPORN",
//         "eng_surname": "CHAIYOT",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000934",
//         "eng_prefix": "MS.",
//         "eng_name": "WARAPORN",
//         "eng_surname": "NUAM-ON",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000933",
//         "eng_prefix": "MS.",
//         "eng_name": "UNCHISA",
//         "eng_surname": "SAMAIKLANG",
//         "position": "General Administration Officer",
//         "department": "Research Promotion and Management Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000932",
//         "eng_prefix": "MS.",
//         "eng_name": "PUNYAWEE",
//         "eng_surname": "THONGKLAD",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000929",
//         "eng_prefix": "MR.",
//         "eng_name": "WEERAPHAT",
//         "eng_surname": "SANGKAEW",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000928",
//         "eng_prefix": "MS.",
//         "eng_name": "PITCHAPON",
//         "eng_surname": "KARNDARAT",
//         "position": "General Administration Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000927",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "NAHUM CARL",
//         "eng_surname": "BROWN",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000926",
//         "eng_prefix": "MR.",
//         "eng_name": "NATTACHAI",
//         "eng_surname": "YASERM",
//         "position": "Technician",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000924",
//         "eng_prefix": "MS.",
//         "eng_name": "JARUNEE",
//         "eng_surname": "KHAMYOD",
//         "position": "General Administration Assistant",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000923",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "YORK HARRY",
//         "eng_surname": "GUNTHER",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Canadian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000922",
//         "eng_prefix": "MR.",
//         "eng_name": "BRUNO",
//         "eng_surname": "MAHON",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "French",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000921",
//         "eng_prefix": "MRS.",
//         "eng_name": "KURNIATI AILING",
//         "eng_surname": "WIRAKOTAN",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Indonesian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000920",
//         "eng_prefix": "MR.",
//         "eng_name": "CHRISTOPHER FOWLER",
//         "eng_surname": "WILLIS",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000919",
//         "eng_prefix": "MR.",
//         "eng_name": "MATTHANA",
//         "eng_surname": "TOHWICHIT",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000918",
//         "eng_prefix": "MR.",
//         "eng_name": "PATIPAN",
//         "eng_surname": "PANPUN",
//         "position": "Civil Engineer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000917",
//         "eng_prefix": "MR.",
//         "eng_name": "JIRAPAT",
//         "eng_surname": "KHAMPLONG",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000916",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "NATTAPOL",
//         "eng_surname": "TANGSUPHOOM",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000915",
//         "eng_prefix": "DR.",
//         "eng_name": "DEEKANA TIPCHANTA",
//         "eng_surname": "KAISER",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000914",
//         "eng_prefix": "MS.",
//         "eng_name": "ANTICHA",
//         "eng_surname": "ARIYATANASUWAN",
//         "position": "Legal Officer",
//         "department": "Central Administration Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000911",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "TREEPON",
//         "eng_surname": "KIRDNARK",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000910",
//         "eng_prefix": "DR.",
//         "eng_name": "PAKAWUT",
//         "eng_surname": "JIRADILOK",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000909",
//         "eng_prefix": "DR.",
//         "eng_name": "DANIELE",
//         "eng_surname": "CARMINATI",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Italian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000908",
//         "eng_prefix": "MRS.",
//         "eng_name": "SUPANSA",
//         "eng_surname": "CHANKHAM",
//         "position": "Finance and Accounting Analyst",
//         "department": "Academic Services Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000907",
//         "eng_prefix": "MS.",
//         "eng_name": "TIPSUDA",
//         "eng_surname": "DOUNGTEAN",
//         "position": "Part-time Officer",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000906",
//         "eng_prefix": "MR.",
//         "eng_name": "THANAPHON",
//         "eng_surname": "KUANGHENG",
//         "position": "General Administration Officer",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000905",
//         "eng_prefix": "MR.",
//         "eng_name": "MAYSA",
//         "eng_surname": "NUTALAI",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000902",
//         "eng_prefix": "DR.",
//         "eng_name": "KERRY JEROME",
//         "eng_surname": "PUSEY",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000901",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "IVAN ATTWOOD",
//         "eng_surname": "STACY",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000900",
//         "eng_prefix": "MS.",
//         "eng_name": "JARUKANYA",
//         "eng_surname": "NOJAK",
//         "position": "Occupation Health Officer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000899",
//         "eng_prefix": "MS.",
//         "eng_name": "CHUTIMA",
//         "eng_surname": "PUANGTONG",
//         "position": "General Administration Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000898",
//         "eng_prefix": "MR.",
//         "eng_name": "NATCHAPON",
//         "eng_surname": "KADU",
//         "position": "Environmentalist",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000897",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "SONGPON",
//         "eng_surname": "TEERAKANOK",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000896",
//         "eng_prefix": "MS.",
//         "eng_name": "PINYANAN",
//         "eng_surname": "WONGTHANASAMITTHI",
//         "position": "General Administration Officer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000894",
//         "eng_prefix": "MR.",
//         "eng_name": "WATTAHA",
//         "eng_surname": "CHALERM",
//         "position": "General Administration Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000893",
//         "eng_prefix": "MR.",
//         "eng_name": "SORRAWIT",
//         "eng_surname": "WANNASORN",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000892",
//         "eng_prefix": "MS.",
//         "eng_name": "ARAYA",
//         "eng_surname": "SENGSAI",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000890",
//         "eng_prefix": "MS.",
//         "eng_name": "RUCHIREK",
//         "eng_surname": "ATTAPOOLSAB",
//         "position": "Legal Officer",
//         "department": "Central Administration Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000889",
//         "eng_prefix": "ศ. ดร.",
//         "eng_name": "NOPRAENUE SAJJARAX",
//         "eng_surname": "DHIRATHITI",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000888",
//         "eng_prefix": "MS.",
//         "eng_name": "CHUTINAT",
//         "eng_surname": "KORPAYAKKIN",
//         "position": "Quality Development  Technical Officer",
//         "department": "Planning Monitoring & Evaluation Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000887",
//         "eng_prefix": "MS.",
//         "eng_name": "ANCHALEE",
//         "eng_surname": "KHUMPHONGPHAN",
//         "position": "General Administration Officer",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000885",
//         "eng_prefix": "MS.",
//         "eng_name": "PIMMADA",
//         "eng_surname": "JAISAWANG",
//         "position": "Educator",
//         "department": "Strategy and Academic Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000884",
//         "eng_prefix": "MR.",
//         "eng_name": "PHUDIS",
//         "eng_surname": "SANSERN",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000883",
//         "eng_prefix": "MS.",
//         "eng_name": "SUPARADA",
//         "eng_surname": "CHAIYAPAN",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000882",
//         "eng_prefix": "MR.",
//         "eng_name": "SIRAWITH",
//         "eng_surname": "KEAWSOMBOON",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000881",
//         "eng_prefix": "MS.",
//         "eng_name": "SUPAWAN",
//         "eng_surname": "SUPANEEDIS",
//         "position": "Assistant Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000880",
//         "eng_prefix": "MR.",
//         "eng_name": "YUTTANA",
//         "eng_surname": "SUNTIVONG",
//         "position": "Assistant Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000879",
//         "eng_prefix": "DR.",
//         "eng_name": "SUPANIDA",
//         "eng_surname": "CHANTARIN",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000878",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "ZAK",
//         "eng_surname": "CALLAWAY",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Canadian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000877",
//         "eng_prefix": "DR.",
//         "eng_name": "CHANCHANOK",
//         "eng_surname": "SUDTA",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000876",
//         "eng_prefix": "DR.",
//         "eng_name": "ORRATHIP",
//         "eng_surname": "GEERATIVUDHIPONG",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000874",
//         "eng_prefix": "MR.",
//         "eng_name": "PARIPAT",
//         "eng_surname": "SALUBSEE",
//         "position": "Public Relation Officer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000871",
//         "eng_prefix": "MR.",
//         "eng_name": "NATTHAPONG",
//         "eng_surname": "INTHITANON",
//         "position": "Mechanical Engineer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000868",
//         "eng_prefix": "MR.",
//         "eng_name": "SORAPOL",
//         "eng_surname": "ASSAWAKARNJANAKIT",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000867",
//         "eng_prefix": "MRS.",
//         "eng_name": "JINDARAT",
//         "eng_surname": "PLOYSUKSAI",
//         "position": "General Service Officer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000866",
//         "eng_prefix": "MR.",
//         "eng_name": "SITTHICHAI",
//         "eng_surname": "CHANTHACHOT",
//         "position": "Engineer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000865",
//         "eng_prefix": "MRS.",
//         "eng_name": "PHANIDA",
//         "eng_surname": "APHIRAMMETHA",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Baby Boomer",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000864",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "PAKORN",
//         "eng_surname": "BOVONSOMBAT",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Baby Boomer",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000859",
//         "eng_prefix": "MS.",
//         "eng_name": "PANYADAO",
//         "eng_surname": "IEM-LA-OR",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000858",
//         "eng_prefix": "DR.",
//         "eng_name": "CHALEENA",
//         "eng_surname": "PIMPASRI",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000856",
//         "eng_prefix": "MS.",
//         "eng_name": "PARICHAT",
//         "eng_surname": "PIAMSAHARD",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000855",
//         "eng_prefix": "MR.",
//         "eng_name": "KITSADA",
//         "eng_surname": "TRONGRUNG",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000853",
//         "eng_prefix": "MS.",
//         "eng_name": "JIDAPA",
//         "eng_surname": "YOOSAMRAN",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000852",
//         "eng_prefix": "MS.",
//         "eng_name": "JUNTIMA",
//         "eng_surname": "NUCHYOTIN",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000850",
//         "eng_prefix": "MR.",
//         "eng_name": "KIATTISAK",
//         "eng_surname": "KHUNSOBNET",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000848",
//         "eng_prefix": "MR.",
//         "eng_name": "SITHICHOK",
//         "eng_surname": "SONGSRI",
//         "position": "Security Guard",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000847",
//         "eng_prefix": "MRS.",
//         "eng_name": "RATCHAYA",
//         "eng_surname": "JAYATILAKA",
//         "position": "General Administration Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000846",
//         "eng_prefix": "MS.",
//         "eng_name": "NISARAT",
//         "eng_surname": "RODKAEW",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000844",
//         "eng_prefix": "MS.",
//         "eng_name": "NAPATT",
//         "eng_surname": "PIYAWONGWATTHANA",
//         "position": "Assistant Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000843",
//         "eng_prefix": "DR.",
//         "eng_name": "BOONTIP",
//         "eng_surname": "BOONBUMROONGSUK",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000842",
//         "eng_prefix": "MS.",
//         "eng_name": "SORAWEE",
//         "eng_surname": "PROMSOMBUT",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000841",
//         "eng_prefix": "MS.",
//         "eng_name": "AKIRASU",
//         "eng_surname": "RODSOODTHI",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000840",
//         "eng_prefix": "MS.",
//         "eng_name": "WALATCHAWAN",
//         "eng_surname": "AKKASRIWORN",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000838",
//         "eng_prefix": "DR.",
//         "eng_name": "SAIFON",
//         "eng_surname": "SINGHATONG",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000837",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "BHANBHASSA",
//         "eng_surname": "DHUBTHIEN",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000836",
//         "eng_prefix": "MR.",
//         "eng_name": "JIRA",
//         "eng_surname": "CHATNARATHIP",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000833",
//         "eng_prefix": "MR.",
//         "eng_name": "PATIPAN",
//         "eng_surname": "WATJANAPRON",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000832",
//         "eng_prefix": "MR.",
//         "eng_name": "SERGIO",
//         "eng_surname": "ESTEBAN REDONDO",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Spanish",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000831",
//         "eng_prefix": "MS.",
//         "eng_name": "MINAR",
//         "eng_surname": "NOPPARAT",
//         "position": "Public Relation Officer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000830",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "KA TAT NIXON",
//         "eng_surname": "CHEN",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Baby Boomer",
//         "gender": "Male",
//         "nationality": "Hongkonger",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000829",
//         "eng_prefix": "DR.",
//         "eng_name": "BRIAN JAMES",
//         "eng_surname": "PHILLIPS",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Baby Boomer",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000826",
//         "eng_prefix": "DR.",
//         "eng_name": "PRANG",
//         "eng_surname": "THARAWANICH",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000824",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "KEVIN ANDREW",
//         "eng_surname": "HART",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000823",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "BABLU KUMAR",
//         "eng_surname": "DHAR",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Bangladeshi",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000821",
//         "eng_prefix": "DR.",
//         "eng_name": "WALLAPA",
//         "eng_surname": "SUENGKAMOLPISUT",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000819",
//         "eng_prefix": "MS.",
//         "eng_name": "CHUTAMAS",
//         "eng_surname": "JAYUUTDISKUL",
//         "position": "Assistant Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000816",
//         "eng_prefix": "MS.",
//         "eng_name": "PIRIE",
//         "eng_surname": "WANGTONG",
//         "position": "General Administration Officer",
//         "department": "Academic Services Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000814",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "AMONRAT",
//         "eng_surname": "THOUMRUNGROJE",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000813",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "ONNIDA",
//         "eng_surname": "THONGPRAVATI",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000812",
//         "eng_prefix": "DR.",
//         "eng_name": "KENNETH BRENDAN",
//         "eng_surname": "HOUSTON",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Irish",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000808",
//         "eng_prefix": "MR.",
//         "eng_name": "KITTAPORN",
//         "eng_surname": "KITSAWAT",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000806",
//         "eng_prefix": "DR.",
//         "eng_name": "PHORUTAI",
//         "eng_surname": "PEARNGAM",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000804",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "LOKWEETPUN",
//         "eng_surname": "SUPRAWAN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000801",
//         "eng_prefix": "MRS.",
//         "eng_name": "SOMLUCK",
//         "eng_surname": "LUNSUCHEEP",
//         "position": "General Administration Officer",
//         "department": "The Office of the Dean",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Baby Boomer",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000800",
//         "eng_prefix": "DR.",
//         "eng_name": "JAMES ALASTAIR",
//         "eng_surname": "WARREN",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000798",
//         "eng_prefix": "DR.",
//         "eng_name": "JARUWAN",
//         "eng_surname": "SAKULKU",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000797",
//         "eng_prefix": "DR.",
//         "eng_name": "ROSANNO ROBINDRANAUTH",
//         "eng_surname": "RAMCHARAN",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Swiss",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000795",
//         "eng_prefix": "MS.",
//         "eng_name": "SIRIMA",
//         "eng_surname": "SANGNARK",
//         "position": "General Administration Officer",
//         "department": "Academic Services Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000794",
//         "eng_prefix": "DR.",
//         "eng_name": "SUPATHIDA",
//         "eng_surname": "KULPAVAROPAS",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000793",
//         "eng_prefix": "MR.",
//         "eng_name": "IAN THOMAS",
//         "eng_surname": "MCDONALD",
//         "position": "Assistant Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000791",
//         "eng_prefix": "MS.",
//         "eng_name": "NATAPORN",
//         "eng_surname": "PRATOOMSUWAN",
//         "position": "Legal Officer",
//         "department": "Central Administration Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000789",
//         "eng_prefix": "MS.",
//         "eng_name": "THANATORN",
//         "eng_surname": "SAMANPHIW",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000788",
//         "eng_prefix": "MS.",
//         "eng_name": "SUWANNA",
//         "eng_surname": "CHUATAMUEN",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000784",
//         "eng_prefix": "MR.",
//         "eng_name": "BANDIT",
//         "eng_surname": "AINSAHWANG",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000783",
//         "eng_prefix": "MR.",
//         "eng_name": "NIKOM",
//         "eng_surname": "PHIODAENG",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000781",
//         "eng_prefix": "MS.",
//         "eng_name": "HARUTAI",
//         "eng_surname": "SRIRUKTHUM",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000780",
//         "eng_prefix": "MRS.",
//         "eng_name": "CHANETTEE",
//         "eng_surname": "POONTHONG",
//         "position": "Finance and Accounting Analyst",
//         "department": "Research Promotion and Management Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000779",
//         "eng_prefix": "MS.",
//         "eng_name": "KANYAKORN",
//         "eng_surname": "PENGCHAROEN",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000777",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "DANIEL",
//         "eng_surname": "PELLERIN",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "German",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000774",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "PETER",
//         "eng_surname": "KURDI",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Hungarian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000773",
//         "eng_prefix": "MS.",
//         "eng_name": "PATHIDA",
//         "eng_surname": "JAMORNTAMAKUL",
//         "position": "Educator",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000772",
//         "eng_prefix": "MR.",
//         "eng_name": "KIATPITACK",
//         "eng_surname": "PUTTIRUNGSIKUL",
//         "position": "Public Relation Officer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000771",
//         "eng_prefix": "MS.",
//         "eng_name": "PATTANIT",
//         "eng_surname": "MEESAENG",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Z",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000769",
//         "eng_prefix": "MS.",
//         "eng_name": "MARY JOAN",
//         "eng_surname": "EPPOLITE",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000767",
//         "eng_prefix": "MS.",
//         "eng_name": "SIRIPRANG",
//         "eng_surname": "CHOTCHAIMONGKOL",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000766",
//         "eng_prefix": "MS.",
//         "eng_name": "PHIM-ON",
//         "eng_surname": "CHEEVAPHITAKPOL",
//         "position": "Educator",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000759",
//         "eng_prefix": "MS.",
//         "eng_name": "PHANITA",
//         "eng_surname": "POOTEANG-ON",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000755",
//         "eng_prefix": "MS.",
//         "eng_name": "JIRAPORN",
//         "eng_surname": "KHONGASEAM",
//         "position": "General Administration Officer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000752",
//         "eng_prefix": "MR.",
//         "eng_name": "PAUL GERARD",
//         "eng_surname": "MURPHY",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000750",
//         "eng_prefix": "MS.",
//         "eng_name": "PORNWISA",
//         "eng_surname": "BUAKHLEE",
//         "position": "Education Technologist",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000749",
//         "eng_prefix": "DR.",
//         "eng_name": "PLOY",
//         "eng_surname": "NIKADANONT",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000747",
//         "eng_prefix": "MS.",
//         "eng_name": "PITTAYARAT",
//         "eng_surname": "LA-ORNGNUAN",
//         "position": "General Administration Assistant",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000746",
//         "eng_prefix": "MR.",
//         "eng_name": "SUPAWAT",
//         "eng_surname": "SUHARITRUJJANANUKOOL",
//         "position": "Mechanical Engineer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000744",
//         "eng_prefix": "MS.",
//         "eng_name": "SUPIDA",
//         "eng_surname": "WANGRATTANAKORN",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000741",
//         "eng_prefix": "MS.",
//         "eng_name": "PIRAPORN",
//         "eng_surname": "NUCHPRASERT",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000734",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "CHOMPUNUCH",
//         "eng_surname": "PONGJIT",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000731",
//         "eng_prefix": "MR.",
//         "eng_name": "WACHIRAWIT",
//         "eng_surname": "PARUNAWIN",
//         "position": "Research Administrator",
//         "department": "Research Promotion and Management Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000728",
//         "eng_prefix": "MS.",
//         "eng_name": "JANTRA",
//         "eng_surname": "JEEBRIAB",
//         "position": "Housekeeper",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000727",
//         "eng_prefix": "MS.",
//         "eng_name": "WARITA",
//         "eng_surname": "CHOCKEKANUNCHAI",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000725",
//         "eng_prefix": "MR.",
//         "eng_name": "PATCHARA",
//         "eng_surname": "SINGRUANG",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000723",
//         "eng_prefix": "MS.",
//         "eng_name": "JIRATCHA",
//         "eng_surname": "ANEKTHANASETH",
//         "position": "Educator",
//         "department": "Alumni Affairs & Career Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000722",
//         "eng_prefix": "MS.",
//         "eng_name": "NAPAPORN",
//         "eng_surname": "JINDAPOL",
//         "position": "Educator",
//         "department": "Alumni Affairs & Career Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000721",
//         "eng_prefix": "DR.",
//         "eng_name": "APINYA",
//         "eng_surname": "CHANGSANOH",
//         "position": "Psychologist",
//         "department": "The Office of the Dean",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000708",
//         "eng_prefix": "MS.",
//         "eng_name": "PIYAWAN",
//         "eng_surname": "JANPEN",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000703",
//         "eng_prefix": "MR.",
//         "eng_name": "SUPATTHARACHAI",
//         "eng_surname": "KHLONGKAN",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000702",
//         "eng_prefix": "MS.",
//         "eng_name": "PALITA",
//         "eng_surname": "SITTIVACH",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000696",
//         "eng_prefix": "MS.",
//         "eng_name": "CHAKRIYA",
//         "eng_surname": "DUANGCHAONA",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000695",
//         "eng_prefix": "MS.",
//         "eng_name": "SITATHAL",
//         "eng_surname": "NGAMNITHICHAVANUN",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000694",
//         "eng_prefix": "MS.",
//         "eng_name": "WARUNYA",
//         "eng_surname": "BAVORNKIJSUTEE",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000692",
//         "eng_prefix": "MS.",
//         "eng_name": "THANIDA",
//         "eng_surname": "SAEU",
//         "position": "General Administration Assistant",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000689",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "OLIMPIA CAVOSORA",
//         "eng_surname": "RACELA",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000688",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "CLAUS DIETER",
//         "eng_surname": "SCHREIER",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Swiss",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000679",
//         "eng_prefix": "MR.",
//         "eng_name": "NATTAWATH",
//         "eng_surname": "SUKAIM",
//         "position": "Technician",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000678",
//         "eng_prefix": "MS.",
//         "eng_name": "KAMONTHIP",
//         "eng_surname": "KITPANAPORN",
//         "position": "General Administration Officer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000675",
//         "eng_prefix": "MS.",
//         "eng_name": "SUPHANNEE",
//         "eng_surname": "SANOI",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000673",
//         "eng_prefix": "MR.",
//         "eng_name": "NOPPORN",
//         "eng_surname": "PIROMNOY",
//         "position": "Technician",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000672",
//         "eng_prefix": "MS.",
//         "eng_name": "SAWAI",
//         "eng_surname": "KHRUPHAN",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000671",
//         "eng_prefix": "MRS.",
//         "eng_name": "KRUEAWAN",
//         "eng_surname": "NOIWONG",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000668",
//         "eng_prefix": "MR.",
//         "eng_name": "TAWATCHAI",
//         "eng_surname": "PHUMKRATHUX",
//         "position": "Technician",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000667",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "JI HYE JAIME",
//         "eng_surname": "CHUNG",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Korean",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000665",
//         "eng_prefix": "MR.",
//         "eng_name": "PONGPHATTRA",
//         "eng_surname": "BURAPACHIT",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000663",
//         "eng_prefix": "MR.",
//         "eng_name": "PRATUAN",
//         "eng_surname": "CHANUDON",
//         "position": "Technician",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000662",
//         "eng_prefix": "MR.",
//         "eng_name": "NATTAPON",
//         "eng_surname": "BOONSUKKHO",
//         "position": "Technician",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000661",
//         "eng_prefix": "MS.",
//         "eng_name": "ROMMANEE",
//         "eng_surname": "PADWICHIT",
//         "position": "Information Resource Analyst",
//         "department": "Library Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000660",
//         "eng_prefix": "MR.",
//         "eng_name": "JAN",
//         "eng_surname": "STEVENER",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "German",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000658",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "YOUCEF NASSIM",
//         "eng_surname": "DEHOUCHE",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Algerian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000657",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "PLOY",
//         "eng_surname": "SUD-ON",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000654",
//         "eng_prefix": "MR.",
//         "eng_name": "TINNABHOP",
//         "eng_surname": "VEJ APORN",
//         "position": "Architect",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000653",
//         "eng_prefix": "MR.",
//         "eng_name": "SETRAWUT",
//         "eng_surname": "PHUYNONGPHO",
//         "position": "Environmentalist",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000652",
//         "eng_prefix": "MR.",
//         "eng_name": "CHAKKAPHON",
//         "eng_surname": "SINGTOPHUEAK",
//         "position": "Audio-Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000651",
//         "eng_prefix": "MR.",
//         "eng_name": "NIWAT",
//         "eng_surname": "SRISOMPOCH",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000650",
//         "eng_prefix": "MS.",
//         "eng_name": "SUTASINEE",
//         "eng_surname": "TEEKABUT",
//         "position": "Educator",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000649",
//         "eng_prefix": "MR.",
//         "eng_name": "KITSANA",
//         "eng_surname": "CHUNCHOM",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000648",
//         "eng_prefix": "DR.",
//         "eng_name": "AMAN",
//         "eng_surname": "SAGGU",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000645",
//         "eng_prefix": "DR.",
//         "eng_name": "WEERAPONG",
//         "eng_surname": "PHADUNGSUKANAN",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000643",
//         "eng_prefix": "DR.",
//         "eng_name": "CHAIVATNA",
//         "eng_surname": "SUMETPHONG",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000637",
//         "eng_prefix": "MS.",
//         "eng_name": "WANWISA",
//         "eng_surname": "LAMTRAKUL",
//         "position": "General Administration Officer",
//         "department": "Academic Services Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000635",
//         "eng_prefix": "MS.",
//         "eng_name": "WASSANA",
//         "eng_surname": "KANGNGA",
//         "position": "General Administration Assistant",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000628",
//         "eng_prefix": "MS.",
//         "eng_name": "SASITHON",
//         "eng_surname": "PANYANAK",
//         "position": "Research Administrator",
//         "department": "Research Promotion and Management Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000627",
//         "eng_prefix": "MS.",
//         "eng_name": "ANOTHAI",
//         "eng_surname": "SAELEE",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000626",
//         "eng_prefix": "MS.",
//         "eng_name": "PAWIRAT",
//         "eng_surname": "PROMPES",
//         "position": "Educator",
//         "department": "Strategy and Academic Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000624",
//         "eng_prefix": "MS.",
//         "eng_name": "WARANGKANA",
//         "eng_surname": "YIMKOSOL",
//         "position": "Scientist",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000623",
//         "eng_prefix": "MS.",
//         "eng_name": "PORNTIWA",
//         "eng_surname": "KIJSASON",
//         "position": "General Administration Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000618",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "ROMAN",
//         "eng_surname": "MEINHOLD",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Dutch",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000614",
//         "eng_prefix": "MR.",
//         "eng_name": "DACHA",
//         "eng_surname": "NAMPRADIT",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000612",
//         "eng_prefix": "MR.",
//         "eng_name": "SAKOL",
//         "eng_surname": "WIKAEWMORAKOT",
//         "position": "Educator",
//         "department": "Strategy and Academic Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000611",
//         "eng_prefix": "MS.",
//         "eng_name": "JANJIRA",
//         "eng_surname": "PHONGBUNDHITWATTHANA",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000599",
//         "eng_prefix": "MR.",
//         "eng_name": "ANDREW CHARLES",
//         "eng_surname": "FORSTER",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Australian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000598",
//         "eng_prefix": "MR.",
//         "eng_name": "COLIN MORGAN",
//         "eng_surname": "CARPENTER",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000595",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "THOTSAPORN",
//         "eng_surname": "THANATIPANONDA",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000594",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "MANCHUTA",
//         "eng_surname": "DANGKULWANICH",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000589",
//         "eng_prefix": "MS.",
//         "eng_name": "VARUNEE",
//         "eng_surname": "RAUDSOOK",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000588",
//         "eng_prefix": "MS.",
//         "eng_name": "TIPWIMON",
//         "eng_surname": "BUACHUM",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000587",
//         "eng_prefix": "MS.",
//         "eng_name": "KANOKWAN",
//         "eng_surname": "KARAWAKE",
//         "position": "Educator",
//         "department": "Graduate Program Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000580",
//         "eng_prefix": "MR.",
//         "eng_name": "ANAN",
//         "eng_surname": "SALANOK",
//         "position": "Security Guard",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000579",
//         "eng_prefix": "DR.",
//         "eng_name": "CHRISTIN  MARIE",
//         "eng_surname": "GROTHAUS",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "German",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000578",
//         "eng_prefix": "MR.",
//         "eng_name": "HENRY  HUMPHREY",
//         "eng_surname": "PFISTER",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000576",
//         "eng_prefix": "MR.",
//         "eng_name": "ADRIANO  ALBERTO",
//         "eng_surname": "QUIETI",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000575",
//         "eng_prefix": "DR.",
//         "eng_name": "NUNNAPAN",
//         "eng_surname": "PUATHANAWAT",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000571",
//         "eng_prefix": "MS.",
//         "eng_name": "KANOKWAN",
//         "eng_surname": "SANGANAN",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000569",
//         "eng_prefix": "MS.",
//         "eng_name": "RAWEEWAN",
//         "eng_surname": "THANUTHONG",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000568",
//         "eng_prefix": "DR.",
//         "eng_name": "JERIMIAH  FREEMAN",
//         "eng_surname": "MORRIS",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000567",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "SARAYUT",
//         "eng_surname": "NATHAPHAN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000565",
//         "eng_prefix": "MR.",
//         "eng_name": "CHATWAROOT",
//         "eng_surname": "DULYACHAI",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000563",
//         "eng_prefix": "MS.",
//         "eng_name": "SONGROT",
//         "eng_surname": "KITSAWAT",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000559",
//         "eng_prefix": "MS.",
//         "eng_name": "NATTIKA",
//         "eng_surname": "PHUNYATERA",
//         "position": "Educator",
//         "department": "Alumni Affairs & Career Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000553",
//         "eng_prefix": "MS.",
//         "eng_name": "WORANAN",
//         "eng_surname": "APITHARANON",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000549",
//         "eng_prefix": "DR.",
//         "eng_name": "TARA",
//         "eng_surname": "CHALERMSONGSAK",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000548",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "TUMNOON",
//         "eng_surname": "CHARASLERTRANGSI",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000546",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "VARANG",
//         "eng_surname": "WIRIYAWIT",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000543",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "VIRIYA",
//         "eng_surname": "TAECHARUNGROJ",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000541",
//         "eng_prefix": "MS.",
//         "eng_name": "THEERANUN",
//         "eng_surname": "LEKSUTHEE",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000539",
//         "eng_prefix": "MR.",
//         "eng_name": "LEIGH",
//         "eng_surname": "PEARSON",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000538",
//         "eng_prefix": "DR.",
//         "eng_name": "ANJANA",
//         "eng_surname": "SUKUMARY",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Indian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000537",
//         "eng_prefix": "DR.",
//         "eng_name": "SARINYA",
//         "eng_surname": "SUNGKATAVAT",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000533",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "PORNRAT",
//         "eng_surname": "RUENGROT",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000532",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "PHASSAWAN",
//         "eng_surname": "SUNTRARUK",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000531",
//         "eng_prefix": "MR.",
//         "eng_name": "NATCHAPHON",
//         "eng_surname": "KHUEANKHAE",
//         "position": "Technician",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000529",
//         "eng_prefix": "MS.",
//         "eng_name": "BUDSARA",
//         "eng_surname": "YARNKOOLWONG",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000524",
//         "eng_prefix": "MS.",
//         "eng_name": "SUPITCHA",
//         "eng_surname": "NUKKONG",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000522",
//         "eng_prefix": "MR.",
//         "eng_name": "THREEPAK",
//         "eng_surname": "PATTARASUMUN",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000518",
//         "eng_prefix": "MS.",
//         "eng_name": "RUNGTIPA",
//         "eng_surname": "SAE-TEAW",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000517",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "CHANCHAI",
//         "eng_surname": "PHONTHANUKITITHAWORN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000516",
//         "eng_prefix": "DR.",
//         "eng_name": "RANGSON",
//         "eng_surname": "CHIRAKRANONT",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000514",
//         "eng_prefix": "MS.",
//         "eng_name": "PAPASSORN",
//         "eng_surname": "PEARPLUK",
//         "position": "General Administration Officer",
//         "department": "Graduate Program Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000513",
//         "eng_prefix": "DR.",
//         "eng_name": "HARDINA",
//         "eng_surname": "OHLENDORF",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "German",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000511",
//         "eng_prefix": "MR.",
//         "eng_name": "KITTIPHAT",
//         "eng_surname": "PHANPRACHA",
//         "position": "Electrician",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000506",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "KANAT",
//         "eng_surname": "TANGWONGSAN",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000505",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "ISABEL MARIA",
//         "eng_surname": "MEDALHO PEREIRA DE FREITAS RODRIGUES",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Portuguese",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000504",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "ALESSANDRO",
//         "eng_surname": "STASI",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Italian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000502",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "APIRADEE",
//         "eng_surname": "WONGKITRUNGRUENG",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000501",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "WANKWAN",
//         "eng_surname": "POLACHAN",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000493",
//         "eng_prefix": "MS.",
//         "eng_name": "WIMONSIRI",
//         "eng_surname": "HEMTANON",
//         "position": "Assistant Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000492",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "SUWADEE",
//         "eng_surname": "TALAWANICH",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000491",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "KANIX",
//         "eng_surname": "BUKKAVESA",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000490",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "PATSARIN  RODPOTHONG",
//         "eng_surname": "WONGKAMHANG",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000489",
//         "eng_prefix": "MR.",
//         "eng_name": "JOSEPH  ANTHONY",
//         "eng_surname": "SERRANI",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000484",
//         "eng_prefix": "MR.",
//         "eng_name": "WAI TAK",
//         "eng_surname": "TO",
//         "position": "Assistant Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Chinese",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000481",
//         "eng_prefix": "MS.",
//         "eng_name": "THIPSUKHON",
//         "eng_surname": "CHUENSODSAI",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000480",
//         "eng_prefix": "MR.",
//         "eng_name": "KRIT",
//         "eng_surname": "PIYARATTANAPIPHAT",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000478",
//         "eng_prefix": "MS.",
//         "eng_name": "YANIN",
//         "eng_surname": "SOMSRI",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000477",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "CHATCHAWAN",
//         "eng_surname": "PANRAKSA",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000476",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "ARAM",
//         "eng_surname": "TANGBOONDUANGJIT",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000472",
//         "eng_prefix": "MR.",
//         "eng_name": "THIRARAT",
//         "eng_surname": "MANEEKUN",
//         "position": "Electrical Engineer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000470",
//         "eng_prefix": "MR.",
//         "eng_name": "ROMAN",
//         "eng_surname": "CHIRASANTA",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000465",
//         "eng_prefix": "MS.",
//         "eng_name": "TASANEE",
//         "eng_surname": "SATEVONGSA",
//         "position": "Human Resources Officer",
//         "department": "The Office of the Dean",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000462",
//         "eng_prefix": "MR.",
//         "eng_name": "THANAWUT",
//         "eng_surname": "MAKAEO",
//         "position": "General Service Officer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000461",
//         "eng_prefix": "DR.",
//         "eng_name": "MONNAPAT",
//         "eng_surname": "KETKUNTORN",
//         "position": "Plan and Policy Analyst",
//         "department": "Planning Monitoring & Evaluation Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000460",
//         "eng_prefix": "MS.",
//         "eng_name": "SUKANYA",
//         "eng_surname": "RATTANATARATIKUN",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000450",
//         "eng_prefix": "MS.",
//         "eng_name": "KANOKEPORN",
//         "eng_surname": "PREMPIYAMONTRI",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000449",
//         "eng_prefix": "MS.",
//         "eng_name": "METPARIYA",
//         "eng_surname": "KIRATIWATTANAKOON",
//         "position": "Education Technologist",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000448",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "THANARERK",
//         "eng_surname": "THANAKIJSOMBAT",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000447",
//         "eng_prefix": "DR.",
//         "eng_name": "NUTTHABOON",
//         "eng_surname": "PORNRATTANACHAROEN",
//         "position": "Public Relation Officer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000446",
//         "eng_prefix": "MRS.",
//         "eng_name": "ANCHISA",
//         "eng_surname": "KANJANARUJIVUT",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000444",
//         "eng_prefix": "MR.",
//         "eng_name": "PRAWIT",
//         "eng_surname": "HNGIMHYUN",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000439",
//         "eng_prefix": "MS.",
//         "eng_name": "KUNYAPAT",
//         "eng_surname": "KAEWCHA",
//         "position": "General Administration Officer",
//         "department": "Central Administration Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000438",
//         "eng_prefix": "MS.",
//         "eng_name": "PUCKVIPA",
//         "eng_surname": "UA-AMORNWANIT",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000437",
//         "eng_prefix": "MS.",
//         "eng_name": "SITHAPAN",
//         "eng_surname": "VIRIYAMANO",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000436",
//         "eng_prefix": "MR.",
//         "eng_name": "CHALIT",
//         "eng_surname": "LAPROM",
//         "position": "Security Guard",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000433",
//         "eng_prefix": "DR.",
//         "eng_name": "KAL",
//         "eng_surname": "ELLE",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000431",
//         "eng_prefix": "MR.",
//         "eng_name": "ANDREW",
//         "eng_surname": "LEICESTER",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Australian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000430",
//         "eng_prefix": "MRS.",
//         "eng_name": "DUANGDUEAN",
//         "eng_surname": "SAENGPRAEW",
//         "position": "Educator",
//         "department": "Strategy and Academic Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000428",
//         "eng_prefix": "MR.",
//         "eng_name": "JETAPASS",
//         "eng_surname": "SAOTHONG",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000427",
//         "eng_prefix": "MS.",
//         "eng_name": "PUNYAWEE",
//         "eng_surname": "PHUENGWATTANAPANICH",
//         "position": "Educator",
//         "department": "Strategy and Academic Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000424",
//         "eng_prefix": "MS.",
//         "eng_name": "THONGDA",
//         "eng_surname": "WONGSURIYA",
//         "position": "Housekeeper",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000421",
//         "eng_prefix": "MS.",
//         "eng_name": "JIDAPA",
//         "eng_surname": "JOSEN",
//         "position": "General Administration Officer",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000414",
//         "eng_prefix": "MS.",
//         "eng_name": "NUTTAPORN",
//         "eng_surname": "HAMONTRI",
//         "position": "Educator",
//         "department": "Strategy and Academic Development Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000413",
//         "eng_prefix": "MR.",
//         "eng_name": "SAKON",
//         "eng_surname": "LUMPONGPHAN",
//         "position": "Computer Information Analyst",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000409",
//         "eng_prefix": "MR.",
//         "eng_name": "WICHIAN",
//         "eng_surname": "YUENYAO",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000408",
//         "eng_prefix": "MR.",
//         "eng_name": "GREG",
//         "eng_surname": "NOLAND",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000407",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "XIAOXIA",
//         "eng_surname": "WEI",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Chinese",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000404",
//         "eng_prefix": "MS.",
//         "eng_name": "THANYA",
//         "eng_surname": "UTTRAPORN",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000401",
//         "eng_prefix": "MS.",
//         "eng_name": "SUNTAREE",
//         "eng_surname": "SANGSEE",
//         "position": "General Administration Officer",
//         "department": "Central Administration Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000399",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "MATTHEW ROBERT",
//         "eng_surname": "FERGUSON",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Canadian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000396",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "SUPARA",
//         "eng_surname": "KAPASUWAN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000392",
//         "eng_prefix": "MR.",
//         "eng_name": "NOPPADOL",
//         "eng_surname": "PHUEAKLAO",
//         "position": "Security Guard",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000391",
//         "eng_prefix": "MR.",
//         "eng_name": "SUCHAI",
//         "eng_surname": "KRASAESOM",
//         "position": "Gardener",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000390",
//         "eng_prefix": "DR.",
//         "eng_name": "JUAN CARLOS",
//         "eng_surname": "OLMOS ALCOY",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Spanish",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000388",
//         "eng_prefix": "MR.",
//         "eng_name": "GEORGE T.",
//         "eng_surname": "AMURAO",
//         "position": "Web Content Specialist",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Filipino",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000380",
//         "eng_prefix": "MRS.",
//         "eng_name": "THITAREE",
//         "eng_surname": "SANORKUM",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000379",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "DOLCHAI",
//         "eng_surname": "LA-ORNUAL",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000376",
//         "eng_prefix": "MS.",
//         "eng_name": "SUPAPORN",
//         "eng_surname": "PHOMSURIN",
//         "position": "Scientist",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000374",
//         "eng_prefix": "MR.",
//         "eng_name": "JULIEN",
//         "eng_surname": "HARDY",
//         "position": "Assistant Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "French",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000372",
//         "eng_prefix": "MS.",
//         "eng_name": "PATTAKA",
//         "eng_surname": "SA-NGIMNET",
//         "position": "Assistant Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Assistant Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000370",
//         "eng_prefix": "MS.",
//         "eng_name": "PORNNAPAT",
//         "eng_surname": "PRAMCHOTE",
//         "position": "Quality Development  Technical Officer",
//         "department": "Planning Monitoring & Evaluation Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000359",
//         "eng_prefix": "MR.",
//         "eng_name": "NUTTAWUT",
//         "eng_surname": "PINPRACHA",
//         "position": "General Service Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000358",
//         "eng_prefix": "MS.",
//         "eng_name": "PANISARA",
//         "eng_surname": "AKARASINAKUL",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000357",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "BENJALUX",
//         "eng_surname": "SAKUNASINGHA",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000351",
//         "eng_prefix": "MR.",
//         "eng_name": "NATTHAPONG",
//         "eng_surname": "BUASAI",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000347",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "DISSATAT",
//         "eng_surname": "PRASERTSAKUL",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000346",
//         "eng_prefix": "PROF.",
//         "eng_name": "CHULATHIDA",
//         "eng_surname": "CHOMCHAI",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000344",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "CHAYANANT",
//         "eng_surname": "HONGFA",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000341",
//         "eng_prefix": "MR.",
//         "eng_name": "BOONLUA",
//         "eng_surname": "BUASRI",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000339",
//         "eng_prefix": "MS.",
//         "eng_name": "KAMONTHIP",
//         "eng_surname": "KITTIWUTRUNGRUANG",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000333",
//         "eng_prefix": "MS.",
//         "eng_name": "PRANG",
//         "eng_surname": "SIRIPHAND",
//         "position": "Public Relation Officer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000327",
//         "eng_prefix": "DR.",
//         "eng_name": "VEERADES",
//         "eng_surname": "PANVISAVAS",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000313",
//         "eng_prefix": "MR.",
//         "eng_name": "KORAKOT",
//         "eng_surname": "INTARAWECH",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000308",
//         "eng_prefix": "MS.",
//         "eng_name": "AGNIESZKA TERESA",
//         "eng_surname": "ATTHASIT",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Polish",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000305",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "CHANIDA",
//         "eng_surname": "HANSAWASDI",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000299",
//         "eng_prefix": "MR.",
//         "eng_name": "KITTIRAT",
//         "eng_surname": "PRUETHONG",
//         "position": "Electrical Engineer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000295",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "MALINVISA",
//         "eng_surname": "SAKDIYAKORN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000294",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "PANDEJ",
//         "eng_surname": "CHINTRAKARN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000293",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "DYNAYA",
//         "eng_surname": "BHUTIPUNTHU",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000291",
//         "eng_prefix": "DR.",
//         "eng_name": "MILLICENT MARGARET AMANDA JANE",
//         "eng_surname": "YOUNG",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000287",
//         "eng_prefix": "ASSOC.PROF.",
//         "eng_name": "DALE ALAN",
//         "eng_surname": "KONSTANZ",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000286",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "ANALIZA LIEZL PEREZ",
//         "eng_surname": "AMURAO",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Filipino",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000284",
//         "eng_prefix": "DR.",
//         "eng_name": "BRYAN EDWARD",
//         "eng_surname": "OTT",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000282",
//         "eng_prefix": "MS.",
//         "eng_name": "RUJIRA",
//         "eng_surname": "SUKUMPEE",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000281",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "NUNTANA",
//         "eng_surname": "UDOMKIT",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000278",
//         "eng_prefix": "MRS.",
//         "eng_name": "PHANNEE",
//         "eng_surname": "MEEPROM",
//         "position": "Housekeeper",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000276",
//         "eng_prefix": "MR.",
//         "eng_name": "PONGSATORN",
//         "eng_surname": "KAEWMESRI",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000271",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "WALANCHALEE",
//         "eng_surname": "WATTANACHAROENSIL",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000270",
//         "eng_prefix": "MR.",
//         "eng_name": "ARTIT",
//         "eng_surname": "TAWEEDEIT",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000269",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "ORNLATCHA",
//         "eng_surname": "SIVARAK",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000258",
//         "eng_prefix": "MS.",
//         "eng_name": "CAROL ANN",
//         "eng_surname": "SIATRAS",
//         "position": "Lecturer",
//         "department": "Fine and Applied  Arts Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000256",
//         "eng_prefix": "MR.",
//         "eng_name": "SUPAT",
//         "eng_surname": "CHANPEN",
//         "position": "General Administration Officer",
//         "department": "Central Administration Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000250",
//         "eng_prefix": "MR.",
//         "eng_name": "CHRISTIAN",
//         "eng_surname": "OESTERHELD",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Dutch",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000249",
//         "eng_prefix": "MR.",
//         "eng_name": "SANTAS",
//         "eng_surname": "LOMSINSUB",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000248",
//         "eng_prefix": "MR.",
//         "eng_name": "KESWIT",
//         "eng_surname": "POOPUAK",
//         "position": "Computer Programmer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000243",
//         "eng_prefix": "MS.",
//         "eng_name": "YUWADEE",
//         "eng_surname": "CHUNLIM",
//         "position": "Librarian",
//         "department": "Library Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000242",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "WILLIAM J.",
//         "eng_surname": "JONES",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000239",
//         "eng_prefix": "MR.",
//         "eng_name": "PREECHA",
//         "eng_surname": "RUAMSAMAK",
//         "position": "General Service Officer",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000237",
//         "eng_prefix": "MR.",
//         "eng_name": "ADISORN",
//         "eng_surname": "SRIWICHA",
//         "position": "Electrician",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000234",
//         "eng_prefix": "MR.",
//         "eng_name": "PARINYA",
//         "eng_surname": "SRIKHAOW",
//         "position": "General Service Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000222",
//         "eng_prefix": "MR.",
//         "eng_name": "MARK E.",
//         "eng_surname": "MANNING",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000221",
//         "eng_prefix": "MS.",
//         "eng_name": "MARIA",
//         "eng_surname": "SIMON",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000217",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "BOONYANIT",
//         "eng_surname": "MATHAYOMCHAN",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000216",
//         "eng_prefix": "MS.",
//         "eng_name": "PUVISA",
//         "eng_surname": "QIUJUAN",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000213",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "GERALD",
//         "eng_surname": "MOSHAMMER",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Austrian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000209",
//         "eng_prefix": "MS.",
//         "eng_name": "SOMPHAT",
//         "eng_surname": "SUKSAMAI",
//         "position": "General Administration Officer",
//         "department": "Central Administration Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000208",
//         "eng_prefix": "DR.",
//         "eng_name": "PORNCHANOK",
//         "eng_surname": "TANEKITTANA",
//         "position": "General Administration Officer",
//         "department": "Academic Services Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000203",
//         "eng_prefix": "MR.",
//         "eng_name": "NATTHAPATCH",
//         "eng_surname": "SIRIPHATCHARACHAIKUL",
//         "position": "Scientist",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000202",
//         "eng_prefix": "MS.",
//         "eng_name": "JITTRAPA",
//         "eng_surname": "VUTTHIKORNPUN",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000200",
//         "eng_prefix": "MS.",
//         "eng_name": "TEERAWAN",
//         "eng_surname": "NUNTAKIJ",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000199",
//         "eng_prefix": "MS.",
//         "eng_name": "ROMRAWIN",
//         "eng_surname": "HOMSAWAN",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000196",
//         "eng_prefix": "MS.",
//         "eng_name": "SARINYA",
//         "eng_surname": "SAIHOM",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000195",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "NATANAREE",
//         "eng_surname": "POSRITHONG",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000192",
//         "eng_prefix": "MS.",
//         "eng_name": "WIMOL",
//         "eng_surname": "THONGRUNG",
//         "position": "General Administration Officer",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000187",
//         "eng_prefix": "MR.",
//         "eng_name": "YUTHAPONG",
//         "eng_surname": "THITIMONGKOL",
//         "position": "Security Guard",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000185",
//         "eng_prefix": "MR.",
//         "eng_name": "CHAIWAT",
//         "eng_surname": "GRINSRITHONG",
//         "position": "Technician",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000184",
//         "eng_prefix": "MRS.",
//         "eng_name": "SOMPHON",
//         "eng_surname": "NENPLOY",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000183",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "KANDAPA",
//         "eng_surname": "THANASUTA",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000181",
//         "eng_prefix": "MR.",
//         "eng_name": "PRATCHAYA",
//         "eng_surname": "LEELAPRATCHAYANONT",
//         "position": "Graphic Designer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000178",
//         "eng_prefix": "MS.",
//         "eng_name": "ANISA",
//         "eng_surname": "MEKAPORN",
//         "position": "General Administration Officer",
//         "department": "The Office of the Dean",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000177",
//         "eng_prefix": "MRS.",
//         "eng_name": "SOPA",
//         "eng_surname": "NARKPOMCHIN",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000173",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "KAEWTA",
//         "eng_surname": "MUANGASAME",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000170",
//         "eng_prefix": "MR.",
//         "eng_name": "WASAN",
//         "eng_surname": "BAIDAY",
//         "position": "Gardener",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000169",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "NIRUTCHARA",
//         "eng_surname": "LAOHAPRASIT",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000167",
//         "eng_prefix": "MS.",
//         "eng_name": "JEERAWAN",
//         "eng_surname": "THONGSAKOL",
//         "position": "Educator",
//         "department": "Research Promotion and Management Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000163",
//         "eng_prefix": "DR.",
//         "eng_name": "KRITYA",
//         "eng_surname": "BUNCHONGCHIT",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000161",
//         "eng_prefix": "MR.",
//         "eng_name": "GARY FRANK",
//         "eng_surname": "WADDELL II",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "American",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000160",
//         "eng_prefix": "MR.",
//         "eng_name": "AEKSING",
//         "eng_surname": "WEERASAWAINON",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000159",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "SIRITHIDA",
//         "eng_surname": "CHAIVISUTTANGKUN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000158",
//         "eng_prefix": "MR.",
//         "eng_name": "RATTASORN",
//         "eng_surname": "RODKRATHUEK",
//         "position": "Technician",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000157",
//         "eng_prefix": "MS.",
//         "eng_name": "SUNTHAREE",
//         "eng_surname": "TUMMAVIPHAT",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000149",
//         "eng_prefix": "MS.",
//         "eng_name": "NUCHJAREE",
//         "eng_surname": "CHANTORN",
//         "position": "Librarian",
//         "department": "Library Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000148",
//         "eng_prefix": "MS.",
//         "eng_name": "SUWASSA",
//         "eng_surname": "PLUBPLACHAI",
//         "position": "Computer Information Analyst",
//         "department": "Library Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000146",
//         "eng_prefix": "MS.",
//         "eng_name": "SITA",
//         "eng_surname": "WITCHAYAKIJKUL",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000144",
//         "eng_prefix": "MRS.",
//         "eng_name": "PATTHARAT",
//         "eng_surname": "UATHAWEESAMPHAN",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000143",
//         "eng_prefix": "MRS.",
//         "eng_name": "NARIRAT",
//         "eng_surname": "RODMA",
//         "position": "Educator",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000142",
//         "eng_prefix": "MR.",
//         "eng_name": "SITTICHOKE",
//         "eng_surname": "KRASIN",
//         "position": "General Service Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000141",
//         "eng_prefix": "MR.",
//         "eng_name": "SOMPON",
//         "eng_surname": "BUACHAN",
//         "position": "Educator",
//         "department": "Graduate Program Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000139",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "YINGYOT",
//         "eng_surname": "CHIARAVUTTHI",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000137",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "THANYAWEE",
//         "eng_surname": "PRATOOMSUWAN",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000136",
//         "eng_prefix": "MR.",
//         "eng_name": "SURASAK",
//         "eng_surname": "SAWANGPONG",
//         "position": "Security Guard",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000134",
//         "eng_prefix": "MR.",
//         "eng_name": "SANTI",
//         "eng_surname": "PLOYSUGSAI",
//         "position": "Driver",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000128",
//         "eng_prefix": "MS.",
//         "eng_name": "THIDARAT",
//         "eng_surname": "CHARUWAT",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000125",
//         "eng_prefix": "MRS.",
//         "eng_name": "SAWITREE",
//         "eng_surname": "PITCHAYACHAI",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000120",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "RUCHI",
//         "eng_surname": "AGARWAL",
//         "position": "Lecturer",
//         "department": "Social Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Indian",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000116",
//         "eng_prefix": "MS.",
//         "eng_name": "UBONWAN",
//         "eng_surname": "SONGKRANTANON",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000115",
//         "eng_prefix": "MRS.",
//         "eng_name": "ANCHALEE",
//         "eng_surname": "LEELAPRATCHAYANONT",
//         "position": "General Administration Officer",
//         "department": "Academic Services Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000113",
//         "eng_prefix": "MRS.",
//         "eng_name": "SUPATRA",
//         "eng_surname": "NONTAPHA",
//         "position": "Librarian",
//         "department": "Library Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000112",
//         "eng_prefix": "MR.",
//         "eng_name": "SONGPOLE",
//         "eng_surname": "SANGTHONG",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000110",
//         "eng_prefix": "DR.",
//         "eng_name": "LADDAWAN",
//         "eng_surname": "JIANVITTAYAKIT",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000109",
//         "eng_prefix": "MS.",
//         "eng_name": "VEENA",
//         "eng_surname": "THAVORNLOHA",
//         "position": "Educator",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000107",
//         "eng_prefix": "DR.",
//         "eng_name": "PRATEEP",
//         "eng_surname": "WONGVERAYUT",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000100",
//         "eng_prefix": "MS.",
//         "eng_name": "WANNAPAN",
//         "eng_surname": "ONYAEM",
//         "position": "Plan and Policy Analyst",
//         "department": "Planning Monitoring & Evaluation Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000098",
//         "eng_prefix": "MS.",
//         "eng_name": "YUBOL",
//         "eng_surname": "BOONJARAN",
//         "position": "Education Technologist",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000097",
//         "eng_prefix": "MR.",
//         "eng_name": "CHAYANON",
//         "eng_surname": "POONTHONG",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000096",
//         "eng_prefix": "MS.",
//         "eng_name": "WORADA",
//         "eng_surname": "APIRAT",
//         "position": "Foreign Relations Officer",
//         "department": "International Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000091",
//         "eng_prefix": "MR.",
//         "eng_name": "RUSSELL",
//         "eng_surname": "PATTINSON",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000089",
//         "eng_prefix": "MRS.",
//         "eng_name": "SAKULLAYA",
//         "eng_surname": "KRASIN",
//         "position": "Educator",
//         "department": "Graduate Program Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000088",
//         "eng_prefix": "DR.",
//         "eng_name": "WAYNE NICHOLAS",
//         "eng_surname": "PHILLIPS",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "British",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000087",
//         "eng_prefix": "MR.",
//         "eng_name": "VORODOM",
//         "eng_surname": "VIRAVONG",
//         "position": "Instructor",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Instructor",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000083",
//         "eng_prefix": "MRS.",
//         "eng_name": "JUMLONG",
//         "eng_surname": "PHIROMNOI",
//         "position": "Housekeeper",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000081",
//         "eng_prefix": "MRS.",
//         "eng_name": "ROSSUKON",
//         "eng_surname": "PRANET",
//         "position": "Public Relation Officer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000080",
//         "eng_prefix": "MR.",
//         "eng_name": "WIROT",
//         "eng_surname": "SUPACHOKCHONLAKUL",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000078",
//         "eng_prefix": "MR.",
//         "eng_name": "TANASAK",
//         "eng_surname": "POUNGSUB",
//         "position": "General Service Officer",
//         "department": "Aditayathorn Building Group",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000075",
//         "eng_prefix": "MS.",
//         "eng_name": "PHATSIRI",
//         "eng_surname": "CHANCHIM",
//         "position": "Computer Information Analyst",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000074",
//         "eng_prefix": "MR.",
//         "eng_name": "PORAMIN",
//         "eng_surname": "BHEGANAN",
//         "position": "Lecturer",
//         "department": "Science Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000073",
//         "eng_prefix": "MR.",
//         "eng_name": "THAMMACHART",
//         "eng_surname": "KANJANAPINYO",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000072",
//         "eng_prefix": "MS.",
//         "eng_name": "KETVAREE",
//         "eng_surname": "PHATANAKEAW",
//         "position": "Public Relation Officer",
//         "department": "Corporate Communications Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000069",
//         "eng_prefix": "MS.",
//         "eng_name": "PRAEWTHIP",
//         "eng_surname": "WONGPAIBOON",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000066",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "MICHAEL",
//         "eng_surname": "NAGLIS",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000065",
//         "eng_prefix": "MRS.",
//         "eng_name": "JUTHARAT",
//         "eng_surname": "THIPBOONSUP",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000061",
//         "eng_prefix": "MS.",
//         "eng_name": "PIMLADA",
//         "eng_surname": "RUNGPATMETEEKUL",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000059",
//         "eng_prefix": "ASSOC.PROF.",
//         "eng_name": "TAKAYOSHI",
//         "eng_surname": "FUJIWARA",
//         "position": "Lecturer",
//         "department": "Humanities and Language Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Japanese",
//         "employee_count": "1",
//         "is_thai": "0",
//         "is_foreigner": "1"
//     },
//     {
//         "employee_id": "13000058",
//         "eng_prefix": "MRS.",
//         "eng_name": "NATCHA",
//         "eng_surname": "PHOUNGSOMBAT",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000053",
//         "eng_prefix": "ASST.PROF. DR.",
//         "eng_name": "SOMPONG",
//         "eng_surname": "AMNUAY-NGERNTRA",
//         "position": "Lecturer",
//         "department": "Tourism and Hospitality Management Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000052",
//         "eng_prefix": "MS.",
//         "eng_name": "KETSIRIN",
//         "eng_surname": "CHEWPRECHA",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000051",
//         "eng_prefix": "ASSOC.PROF. DR.",
//         "eng_name": "VEERA",
//         "eng_surname": "BHATIASEVI",
//         "position": "Lecturer",
//         "department": "Business Administration Division",
//         "muic_staff_type": "Lecturer",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000050",
//         "eng_prefix": "MS.",
//         "eng_name": "TANNALIN",
//         "eng_surname": "SIRIPHATCHARACHAIKUL",
//         "position": "Information Resource Analyst",
//         "department": "Library Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000048",
//         "eng_prefix": "MR.",
//         "eng_name": "PONLAPAT",
//         "eng_surname": "MUNYANON",
//         "position": "Computer Technical Officer",
//         "department": "Information Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000045",
//         "eng_prefix": "MS.",
//         "eng_name": "PATHYPHORN",
//         "eng_surname": "THITIMONGKOL",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000039",
//         "eng_prefix": "MR.",
//         "eng_name": "KATIPOOM",
//         "eng_surname": "NOIWONG",
//         "position": "General Service Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen Y",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000035",
//         "eng_prefix": "MRS.",
//         "eng_name": "CHANITA",
//         "eng_surname": "NGAMKUNNATHAM",
//         "position": "Human Resources Officer",
//         "department": "Human Resources Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000033",
//         "eng_prefix": "MS.",
//         "eng_name": "SUDAPORN",
//         "eng_surname": "YOOSAWAS",
//         "position": "Educator",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000031",
//         "eng_prefix": "MR.",
//         "eng_name": "ANITUS",
//         "eng_surname": "RAVUNGCHON",
//         "position": "General Service Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000029",
//         "eng_prefix": "MS.",
//         "eng_name": "SATJA",
//         "eng_surname": "SOPHA",
//         "position": "Educator",
//         "department": "Preparation Center for Languages and Mathematics",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000024",
//         "eng_prefix": "MR.",
//         "eng_name": "KAWIN",
//         "eng_surname": "MONGKOLPRAPA",
//         "position": "Plan and Policy Analyst",
//         "department": "Planning Monitoring & Evaluation Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000023",
//         "eng_prefix": "MS.",
//         "eng_name": "CHANPEN",
//         "eng_surname": "KHUNSONG",
//         "position": "General Administration Officer",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000022",
//         "eng_prefix": "MR.",
//         "eng_name": "PONGPAKDEE",
//         "eng_surname": "HONGTHONG",
//         "position": "Audio Visual Officer",
//         "department": "Educational Technology Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000020",
//         "eng_prefix": "MR.",
//         "eng_name": "PUTTHIPAT",
//         "eng_surname": "SIRICHOTCHARINTHORN",
//         "position": "General Service Officer",
//         "department": "Educational Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000019",
//         "eng_prefix": "MRS.",
//         "eng_name": "PRAPAI",
//         "eng_surname": "PIROMNOI",
//         "position": "General Service Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000018",
//         "eng_prefix": "MS.",
//         "eng_name": "RANDA",
//         "eng_surname": "RUJICHINNAWONG",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000017",
//         "eng_prefix": "MRS.",
//         "eng_name": "PORNTHIP",
//         "eng_surname": "PIAMKHUM",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000016",
//         "eng_prefix": "MS.",
//         "eng_name": "SUCHANANT",
//         "eng_surname": "TANJAROENTHAM",
//         "position": "General Administration Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000015",
//         "eng_prefix": "MRS.",
//         "eng_name": "PATHITA",
//         "eng_surname": "SUWANWONG",
//         "position": "Educator",
//         "department": "Admissions and Registrar Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000014",
//         "eng_prefix": "MS.",
//         "eng_name": "SASITHORN",
//         "eng_surname": "ROJSONGKRAM",
//         "position": "Educator",
//         "department": "Student Affairs Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000013",
//         "eng_prefix": "MRS.",
//         "eng_name": "ARUNEE",
//         "eng_surname": "KORSAWADPAT",
//         "position": "Finance and Accounting Analyst",
//         "department": "Finance & Accounting Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000008",
//         "eng_prefix": "MS.",
//         "eng_name": "AREE",
//         "eng_surname": "KONGAMNAT",
//         "position": "Supply Analyst",
//         "department": "Procurement Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Female",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     },
//     {
//         "employee_id": "13000002",
//         "eng_prefix": "MR.",
//         "eng_name": "SITTA",
//         "eng_surname": "KUTSANG",
//         "position": "General Administration Officer",
//         "department": "Operation and Environment Section",
//         "muic_staff_type": "Supporting Staff",
//         "generation": "Gen X",
//         "gender": "Male",
//         "nationality": "Thai",
//         "employee_count": "1",
//         "is_thai": "1",
//         "is_foreigner": "0"
//     }
// ]
